<div class="wizard form_wizard overflow-hidden margin-row">
  <mat-tab-group #tabGroup [selectedIndex]="selectedIndex" (selectedTabChange)="onChangeindex($event.index)">
    <mat-tab label="My Business">
      <div class='innerWizard'>
        <mat-tab-group [selectedIndex]="selectedIndex_inner">
          <mat-tab>
            <div class="col-12 my-2">
              <div class="row">
                <div class="col-12 my-4 text-center" *ngIf="businessList.length === 0">
                  <p>
                    No Business Found
                  </p>
                </div>

                <div class="col-sm-12  col-md-4 col-lg-4 col-xl-4 py-2" *ngFor="let item of businessList"> 
                  <mat-card class="cust_card p-0">
                    <div class="card_head text-left">
                      <mat-card-header>
                        <mat-card-title>
                          {{item.bp_business_name}}
                        </mat-card-title>
                        <div mat-card-avatar class="order-2 ml-auto"
                          *ngIf='item["role_name"] === "Admin" || item["role_name"] === "Advanced" '>
                          <mat-icon class="pointer" [matMenuTriggerFor]='businessMenu'>more_vert</mat-icon>
                          <mat-menu #businessMenu="matMenu">
                            <ul class="tableRowEdit">
                              <li class="morerow" (click)="populateBusiness(item.bp_business_id);">View and Edit</li>
                              <li class="cloneRow" *ngIf="membershipActive" (click)="goToClone(item.bp_business_id,1)">Clone Cannabis Business</li>
                              <li class="cloneRow" *ngIf="membershipActive" (click)="goToClone(item.bp_business_id,2)">Clone Non-Cannabis Business</li>
                            </ul>
                          </mat-menu>
                        </div>
                      </mat-card-header>
                    </div>
                    <mat-card-content>
                      <div class="account_number">
                        <p class="card_sub_title">DBA(Doing Business As)</p>
                        <p class="outer">{{item.bp_business_dba}}</p>
                      </div>
                      <!-- <div class="account_number">
                        <p class="card_sub_title">Display Name</p>
                        <p class="outer">{{item.biz_display_name}}</p>
                      </div> -->

                      <div class="d-flex justify-content-end">


                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <div class="col-12" *ngIf="isloaded">
              <mat-card class="p-0 my-3">
                <div class="row m-0">
                  <div class="col-12">
                    <div class="col-12 p-0 my-2">
                      <button class='mat-button pl-0' (click)="crumSwitch('Home'); resetTabs();selectedIndex_inner = 0;displayedColumns4ListView=true;fileManagementTabs=0"><img
                          src="assets/images/left.png" class='table_head_back'> Back </button>
                    </div>
                    <div class="col-12 p-0">
                      <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item pointer">
                          <a class="nav-link" [ngClass]="{'active':tabvis_edit == 0}" (click)="onTabselect(0)">Business
                            Details</a>
                        </li>
                        <li class="nav-item pointer">
                          <a class="nav-link" [ngClass]="{'active':tabvis_edit == 1}" (click)="onTabselect(1)">Bank
                            Account
                            Details</a>
                        </li>
                        <li class="nav-item pointer" *ngIf="membershipActive">
                          <a class="nav-link" [ngClass]="{'active':tabvis_edit == 2}" (click)="onTabselect(2)">User
                            Details</a>
                        </li>
                        <li class="nav-item pointer" *ngIf="membershipActive">
                          <a class="nav-link" [ngClass]="{'active':tabvis_edit == 3}" (click)="onTabselect(3)">
                            Delivery Addresses</a>
                        </li>
                        <li class="nav-item pointer" *ngIf="membershipActive">
                          <a class="nav-link" [ngClass]="{'active':tabvis_edit == 4}" (click)="onTabselect(4)">Notifications</a>
                        </li>
                        <ng-container>
                          <li class="nav-item pointer">
                            <a class="nav-link" [ngClass]="{'active':tabvis_edit == 5}" (click)="onTabselect(5)">
                              File Management</a>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                    <div class="col-12" *ngIf="tabvis_edit==0">
                      <form [formGroup]='BusinessDetailsBasic_edit'>
                        <div class="row ">
                          <div class="col-12 mt-2">
                            <mat-card class="px-0">
                              <div class="d-flex">
                                <div class="col">
                                  <div class="popupSubTitle_rules">
                                    <span>
                                      Name
                                    </span>
                                  </div>
                                  <div class="blueFont">
                                    <span>
                                      {{cloneBusinessData.name}}
                                    </span>
                                  </div>
                                </div>
                                <div class="col">
                                  <div class="popupSubTitle_rules">
                                    <span>
                                      DBA
                                    </span>
                                  </div>
                                  <div class="blueFont">
                                    <span>
                                      {{cloneBusinessData.dba}}
                                    </span>
                                  </div>
                                </div>
                                <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                                  <div class="popupSubTitle_rules">
                                    <span>
                                      Cannabis Business Type
                                    </span>
                                  </div>
                                  <div class="blueFont">
                                    <span>
                                      {{totalData.license_data?.bp_license_type_name}}
                                    </span>
                                  </div>
                                </div> -->
                              </div>
                            </mat-card>
                          </div>
                          <div class="col-12 my-3 p-0 wiz_title">
                            <span class="Badge">{{titleNoEdit.BasicDetails?.slNo}}</span>
                            <span>
                              Basic Details
                            </span>
                          </div>
                          <div class="col-12">
                            <p class="tabInnerTitle">
                              <span>Business Basic Details</span>
                            </p>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Legal Business Name" formControlName="name" required
                                (change)="isValidBusiness({name:BusinessDetailsBasic_edit.get('name').value,bp_business_id:editBusinessID},
                              {formGroup:BusinessDetailsBasic_edit,formControl:'name'})">
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('name').errors?.required">Enter Legal
                                Business
                                Name
                              </mat-error>
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('name').errors?.exist">
                                {{BusinessDetailsBasic_edit.get('name').errors.exist}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Doing Business As" formControlName="dba">
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('dba').errors?.required">Enter DBA
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Entity Type" formControlName="bp_entity_type"
                                (selectionChange)="changeEntityType($event,BusinessDetailsBasic_edit,'other_entity_edit')"
                                required>
                                <mat-option [value]='item.bp_entity_type_id' *ngFor="let item of businessEntityList">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('bp_entity_type').errors?.required">Select
                                Entity
                                type
                              </mat-error> 
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="State of Incorporation" formControlName="incorp_state">
                                <mat-option *ngFor="let item of stateList" [value]="item.bt_region_id">{{item.name}}
                                </mat-option>
                              </mat-select>
                              <!-- <mat-error *ngIf="BusinessDetailsBasic_edit.get('incorp_state').errors?.required">Select State of
                                Incorporation
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput mask="00-0000000" [showMaskTyped]="true" placeholder="Federal Tax ID/EIN"
                              [formControl]="BusinessDetailsBasic_edit.controls['fed_taxid']">
                              <!-- <mat-error>Enter valid
                                Federal
                                Tax
                                ID/EIN
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                          <div *ngIf='other_entity_edit==1' class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Entity Type" formControlName="bp_entity_type_other" required>
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('bp_entity_type_other').errors?.required">
                                Enter
                                Other
                                Entity
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder=" Business Profile Nickname" formControlName="nickname"
                              (change)="isValidBusiness({nickname:BusinessDetailsBasic_edit.get('nickname').value},
                        {formGroup:BusinessDetailsBasic_edit,formControl:'nickname'})"
                                required>
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('nickname').errors?.required">
                                Enter Business Profile Nickname
                              </mat-error>
                              <mat-error *ngIf="BusinessDetailsBasic_edit.get('nickname').errors?.exist">
                                {{BusinessDetailsBasic_edit.get('nickname').errors.exist}}
                              </mat-error>
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 custom_Errors">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Parent Company" formControlName="parent_bp_business_id"
                                [matAutocomplete]="auto_edit">
                              <mat-autocomplete #auto_edit="matAutocomplete" [displayWith]="displayParent">
                                <mat-option *ngFor="let option of filteredOptions_edit | async" [value]="option">
                                  {{option.bp_business_name}}
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error
                                *ngIf="BusinessDetailsBasic_edit.get('parent_bp_business_id').errors?.required">
                                Select Parent Company
                              </mat-error>
                              <span class="errorMessage warningMessage"
                                *ngIf='(BusinessDetailsBasic_edit.get("parent_bp_business_id").value==="")'>
                                Current business will be set as the parent
                              </span>
                              <span class="errorMessage warningMessage"
                                *ngIf='(BusinessDetailsBasic_edit.get("parent_bp_business_id").value &&
                                  BusinessDetailsBasic_edit.get("parent_bp_business_id").value["bp_business_id"] === editBusinessID)'>
                                Current business has been set as the parent
                              </span>


                            </mat-form-field>

                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Business Type(s)" formControlName="business_type">
                            </mat-form-field>
                          </div>

                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 mt-2" *ngIf="RegType == 1">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Type" [(ngModel)]="tntType" required>
                                <mat-option *ngFor="let item of tntList" [value]="item.bp_tnt_type_id">
                                  {{item?.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 mt-2" *ngIf="RegType == 1">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="State" [(ngModel)]="cannabisState" required>
                                <mat-option *ngFor="let item of Cannabistates" [value]="item.bt_region_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 mt-2" *ngIf="RegType == 1">  
                            <textarea appInputLimit [(ngModel)]="metrcKey" class="chatInputArea w-100" rows="1" placeholder="Enter Key"></textarea>
                            <img   matTooltipClass="matToolTipCmmnt" class="txttooltip"
                            [title]="tooltip" src="/assets/images/i.svg"> &nbsp;&nbsp;
                          </div> -->


                        </div>
                      </form>
                      <!-- <form [formGroup]='CannabisDetails_edit' *ngIf="RegType_edit == 1">

                        <div class="col-12 my-3 p-0 wiz_title">
                          <span class="Badge">{{titleNoEdit.CannabisRelatedDetails?.slNo}}</span>
                          <span>
                            Cannabis Related Details
                          </span>
                        </div>
                        <div class="row ">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Cannabis Business Type" formControlName="CanabusBusnessType"
                                (selectionChange)="changeCannBussType($event, CannabisDetails_edit, 'Canabis_bus_other_type_edit' , 'Lab_edit')"
                                required>
                                <mat-option *ngFor="let item of businessLicenseList" [value]='item'>
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="CannabisDetails_edit.get('CanabusBusnessType').errors?.required">
                                Select
                                Cannabis
                                Business Type</mat-error>
                            </mat-form-field>

                          </div>
                          <div *ngIf='Canabis_bus_other_type_edit==1' class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Cannabis Business Type"
                                formControlName="CanabusBusnessTypeOther">
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Cannabis Licensed Country" formControlName="CountryList" (selectionChange)="getCannabisStates($event.value)">
                                <mat-option *ngFor="let item of Cannabiscountry" [value]="item.bt_country_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="CannabisDetails.get('CountryList').errors">Select Country
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Cannabis Licensed State/Province " formControlName="CannabisLicensedState"
                                required>
                                <mat-option *ngFor="let item of Cannabistates" [value]="item.bt_region_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="CannabisDetails_edit.get('CannabisLicensedState').errors?.required">
                                Cannabis
                                Licensed
                                State </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Cannabis Business License Number"
                                formControlName="CannabisLicenceNumber" (change)="isValidBusiness({license:CannabisDetails_edit.get('CannabisLicenceNumber').value,bp_business_id:editBusinessID},
                                {formGroup:CannabisDetails_edit,formControl:'CannabisLicenceNumber'})"
                                  formControlName="CannabisLicenceNumber" required>
                              <mat-error *ngIf="CannabisDetails_edit.get('CannabisLicenceNumber').errors?.required ||
                              CannabisDetails_edit.get('CannabisLicenceNumber').errors?.invalidLicense
                              ">
                                Enter a valid
                                Cannabis
                                Business License Number</mat-error>
                                <mat-error *ngIf="CannabisDetails_edit.get('CannabisLicenceNumber').errors?.exist">
                                  {{CannabisDetails_edit.get('CannabisLicenceNumber').errors.exist}}
                                </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput [matDatepicker]="picker" [min]='newDateFilter'
                                placeholder="Expiration Date" formControlName="ExpirationDate"  >
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker (opened)="streamOpened()" (closed)="streamClosed()" #picker>
                              </mat-datepicker>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Cannabis Tax ID" formControlName="CannabisTaxID">
                              <mat-error>Enter valid Cannabis Tax ID (only alphabhets , numbers , hyphen and slashes are
                                allowed)
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Cannabis License Category" formControlName="CanabisCategory"
                                (selectionChange)='IsOtherCategory($event, CannabisDetails_edit, "OtherCanbisCategoy_edit")'
                                required>
                                <mat-option *ngFor="let item of CanabisCategorylist"
                                  (click)="CanabisCategory=item.name;" [value]='item.bp_license_type_desig_id'>
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="CannabisDetails_edit.get('CanabisCategory').errors?.required">Select
                                Cannabis
                                License Category</mat-error>
                            </mat-form-field>

                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='OtherCanbisCategoy_edit == 1'>
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Cannabis License Category"
                                formControlName="bp_license_type_desig_comment" required>
                              <mat-error
                                *ngIf="CannabisDetails_edit.get('bp_license_type_desig_comment').errors?.required">
                                Enter
                                Cannabis License Category
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-8 acrediation com-md-8 col-lg-8 col-xl-12 mb-2" *ngIf='Lab_edit==true'>
                            <mat-checkbox class="col-12" formControlName='is_accredited'
                              (change)='IsAcreditedLab(CannabisDetails_edit.get("is_accredited").value , CannabisDetails_edit)'>
                              Is this
                              business
                              an
                              accredited cannabis business?
                            </mat-checkbox>
                          </div>
                        </div>
                        <div class='row accrediations' *ngIf='CannabisDetails_edit.get("is_accredited").value==true'>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Accreditation Standard" formControlName="accreditation_standard"
                                (selectionChange)="changeStandard($event , CannabisDetails_edit)" required>
                                <mat-option *ngFor="let item of accreditionstanList"
                                  [value]='item.bp_accredition_standard_type_id'>
                                  {{item.name}}
                                </mat-option>

                              </mat-select>
                              <mat-error *ngIf="CannabisDetails_edit.get('accreditation_standard').errors?.required">
                                Enter
                                Accreditation Standard
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                            *ngIf='CannabisDetails_edit.get("isOtherStandard").value'>
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Accreditation Standard"
                                formControlName="accredition_standard_comment" required>
                              <mat-error
                                *ngIf="CannabisDetails_edit.get('accredition_standard_comment').errors?.required">
                                Enter
                                Accreditation Standard
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput [matDatepicker]="picker2" [min]='minDate'
                                placeholder="Accreditation Expiration" formControlName="accreditation_expiration"
                                required>
                              <mat-error >
                                Select
                                valid Accreditation Expiration Date
                              </mat-error>
                              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                              <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Certificate Number" formControlName="certificate_number"
                                required>
                              <mat-error *ngIf="CannabisDetails_edit.get('certificate_number').errors?.required">Enter
                                Certificate Number
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Accreditation Number" formControlName="accreditation_no"
                                required>
                              <mat-error *ngIf="CannabisDetails_edit.get('accreditation_no').errors?.required">Enter
                                Accreditation
                                Number
                              </mat-error>
                            </mat-form-field>
                          </div>
 
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Accredited Facility ID"
                                formControlName="accreditation_test_lab_id">
                              <mat-error *ngIf="CannabisDetails_edit.get('accreditation_test_lab_id').errors?.required"
                                required>
                                Enter
                                Facility ID
                              </mat-error>
                            </mat-form-field>
                          </div>

                        </div>


                        <div class='row' *ngIf='CannabisDetails_edit.get("is_accredited").value==true'>


                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 ">
                            <mat-form-field class="col-12">
                              <input type="text" readonly matInput placeholder="Upload Certificate"
                                formControlName="certificate_image">
                              <mat-error *ngIf="CannabisDetails_edit.controls.certificate_image.errors?.required">
                                Upload
                                Certificate
                              </mat-error>
                            </mat-form-field>

                          </div>
                          <div class="col-sm-12 com-md- 3 col-lg-3 col-xl-3 d-flex align-items-baseline">
                            <button class="choosebutton">
                              <input type="file" #attachInputEdit (change)='passCertificate($event , "Edit")'>
                              Choose Certificate
                            </button>
                            <div class="tooltipImg ml-1">
                              <img src="assets/images/i.svg" alt="" [title]="instructionString">
                            </div>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 ">
                            <button mat-raised-button color="primaryCus" (click)='openLicenseHistory()'>View
                              History</button>

                          </div>



                        </div>




                      </form> -->
                      <form [formGroup]='ContactDetails_edit'>
                        <div class="row ">
                          <div class="col-12 my-3 p-0 wiz_title">
                            <!-- <span class="Badge">{{titleNoEdit.ContactDetails?.slNo}}</span> -->
                            <span class="Badge">2</span>
                            <span>
                              Contact Details
                            </span>
                          </div>
                          <div class="col-12">
                            <p class="tabInnerTitle">
                              <span>Legal/Registered Address</span>
                            </p>
                          </div>
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Country" formControlName="CountryList"
                                (selectionChange)="findZipBusinessDetails(ContactDetails_edit)">
                                <mat-option *ngFor="let item of country" [value]="item.bt_country_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="ContactDetails_edit.get('CountryList').errors?.required">Select Country
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Zip Code" formControlName="ZipCode" required>
                              <mat-error *ngIf="ContactDetails_edit.get('ZipCode').errors">Enter a valid Zip Code
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="State" formControlName="State" required>
                              <mat-error *ngIf="ContactDetails_edit.get('State').errors?.required">Enter State
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="County" formControlName="County">
                              <mat-error *ngIf="ContactDetails_edit.get('County').errors?.required">Enter your county
                              </mat-error>
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="City" formControlName="City">
                              <mat-error *ngIf="ContactDetails_edit.get('City').errors?.required">Enter City
                              </mat-error>
                            </mat-form-field>
                          </div> 
                          <!-- <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Street Number" formControlName="StreetNumber" required>
                              <mat-error *ngIf="(ContactDetails_edit.get('StreetNumber').errors?.required ||
                              ContactDetails_edit.get('StreetNumber').errors?.invalidStreetNum ||
                              ContactDetails_edit.get('StreetNumber').errors?.isFullSpace
                               ) &&
                              !ContactDetails_edit.get('StreetNumber').errors?.maxlength
                              ">
                                Enter a valid Street Number
                              </mat-error>
                              <mat-error *ngIf="ContactDetails_edit.get('StreetNumber').errors?.maxlength">
                                Maximum length of street number should be
                                {{ContactDetails_edit.get('StreetNumber').errors.maxlength.requiredLength}}
                              </mat-error>
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Street Address" formControlName="StreetName" (input)="onInputChange($event.target.value, ContactDetails_edit)" required>
                              <mat-error *ngIf="ContactDetails_edit.get('StreetName').errors?.required">Enter Street
                                Address                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Unit" formControlName="Unit">
                              <mat-error>
                                Maximum length of Unit should be
                                {{ContactDetails_edit.get('Unit').errors?.maxlength.requiredLength}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 p-0">
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5">
                              <mat-form-field class="col-12">
                                <input matInput placeholder="Business URL" formControlName="BusinessURL">
                                <mat-error *ngIf="ContactDetails_edit.get('BusinessURL').hasError('pattern')">Enter a valid Business Website URL</mat-error>

                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-12">
                            <mat-checkbox formControlName="is_correct_zip_legal"
                              (change)='BusinessDetailsIncorrectZip($event,ContactDetails_edit)' class="col-12">Edit
                              state, county , city
                              details ?
                            </mat-checkbox>
                          </div>
                         <div *ngIf=" ContactDetails_edit.get('items').controls.length > 0" class="wd_80">
                          <div class="col-12 wd_80" formArrayName="items"
                          *ngFor="let item of ContactDetails_edit.get('items').controls; let i = index;">
                          <div class="row phonearray" [formGroupName]="i">
                            <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">

                              <mat-form-field class="col-12">
                                <input type='text' matInput placeholder="Business Phone Number"
                                  [formControl]="ContactDetails_edit.get('items').controls[i].get('phone')" mask="(000) 000-0000" (keyup)="isDuplicatePhone()"
                                  [showMaskTyped]="true">
                                <mat-error>
                                  Enter a
                                  Valild Business Phone No.</mat-error>
                              </mat-form-field>

                            </div>
                            <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                              <div class="">
                                <mat-form-field class="col-sm-12">
                                  <mat-select placeholder="Business Phone Type" formControlName="phone_type_id">
                                    <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                      {{item.name}}
                                    </mat-option>

                                  </mat-select>
                                  <mat-error
                                    *ngIf="ContactDetails_edit.get('items').controls[i].get('phone_type_id').errors?.required">
                                    Select
                                    Phone Type</mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="col-sm-2  BusAddCnctBtn ">
                              <button class="addBtn newtrash" (click)="CloseItem(item,ContactDetails_edit,'items')"
                                *ngIf="ContactDetails_edit.get('items').controls.length > 1">
                                <img src="assets/images/trash.svg">
                              </button>

                              <button class="addBtn" *ngIf="i == (ContactDetails_edit.get('items').controls.length)-1" style="padding: 2px 5px !important;"
                                [disabled]="ContactDetails_edit.get('items')['controls'][i]['value']['phone']?.length!=10 || !ContactDetails_edit.get('items')['controls'][i]['value']['phone_type_id']"

                                (click)="addItem(ContactDetails_edit,'items')">
                                <img src="assets/images/add.svg">
                              </button>
                            </div>
                          </div>
                        </div>
                         </div>
                          <div class="col-12">
                            <p class="tabInnerTitle">
                              <span>Primary Business Location</span>
                            </p>
                          </div>
                          <div class="col-sm-12 p-0">
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5">
                              <mat-checkbox formControlName="is_legal_premise_addr_same"
                                (change)='DisableBusines_Validation(ContactDetails_edit)' class="col-12">Same as Legal
                                Address
                              </mat-checkbox>
                            </div>
                          </div>


                          <div class="col-12" *ngIf="!ContactDetails_edit.get('is_legal_premise_addr_same').value">
                            <div class="row">
                              <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                <mat-form-field class="col-12">
                                  <mat-select placeholder="Country" formControlName="PreCountryList"
                                    (selectionChange)="findZipBusinessDetailsPrem(ContactDetails_edit)" required>
                                    <mat-option *ngFor="let item of country" [value]="item.bt_country_id">
                                      {{item.name}}
                                    </mat-option>
                                  </mat-select>
                                  <mat-error *ngIf="ContactDetails_edit.get('PreCountryList').errors?.required">Select
                                    Country
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="Zip Code" formControlName="PreZipCode" required>
                                  <mat-error *ngIf="ContactDetails_edit.get('PreZipCode').errors">Enter a valid Zip Code
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="State" formControlName="PreState">
                                  <mat-error *ngIf="ContactDetails_edit.get('PreState').errors?.required">Enter your
                                    state
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <!-- <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="County" formControlName="PreCounty">
                                  <mat-error *ngIf="ContactDetails_edit.get('PreCounty').errors?.required">Enter your
                                    county
                                  </mat-error>
                                </mat-form-field>
                              </div> -->
                              <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="City" formControlName="PreCity">
                                  <mat-error *ngIf="ContactDetails_edit.get('PreCity').errors?.required">Enter City
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <!-- <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="Street Number" formControlName="PreStreetNumber"
                                    required>
                                    <mat-error *ngIf="(ContactDetails_edit.get('PreStreetNumber').errors?.required ||
                                    ContactDetails_edit.get('PreStreetNumber').errors?.invalidStreetNum  ||
                                    ContactDetails_edit.get('PreStreetNumber').errors?.isFullSpace
                                    ) &&
                                    !ContactDetails_edit.get('PreStreetNumber').errors?.maxlength
                                    ">
                                      Enter a valid Street Number
                                    </mat-error>
                                  <mat-error *ngIf="ContactDetails_edit.get('PreStreetNumber').errors?.maxlength">
                                    Maximum length of street number should be
                                    {{ContactDetails_edit.get('PreStreetNumber').errors.maxlength.requiredLength}}
                                  </mat-error>
                                </mat-form-field>
                              </div> -->
                              <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3" required>
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="Street Address" formControlName="PreStreetName">
                                  <mat-error *ngIf="ContactDetails_edit.get('PreStreetName').errors?.required">Enter
                                    Street
                                    Address
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                                <mat-form-field class="col-12">
                                  <input matInput placeholder="Unit" formControlName="PreUnit">
                                  <mat-error>
                                    Maximum length of Unit should be
                                    {{ContactDetails_edit.get('PreUnit').errors?.maxlength.requiredLength}}
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-12">
                                <mat-checkbox formControlName="is_correct_zip_pre"
                                  (change)='BusinessDetailsPreIncorrectZip($event,ContactDetails_edit)' class="col-12">
                                  Edit state, county
                                  ,
                                  city
                                  details ?
                                </mat-checkbox>
                              </div>
                              <div class="col-12" formArrayName="Preitems"
                                *ngFor="let item of ContactDetails_edit.get('Preitems').controls; let i = index;">
                                <div class="row" [formGroupName]="i">
                                  <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">

                                    <mat-form-field class="col-12">
                                      <input type='text' matInput placeholder="Business Phone Number"
                                      [formControl]="ContactDetails_edit.get('Preitems').controls[i].get('phone')" mask="(000) 000-0000" (keyup)="isDuplicatePhone()"
                                        [showMaskTyped]="true">
                                      <mat-error>
                                        Enter a valid Business Phone No.</mat-error>
                                    </mat-form-field>

                                  </div>
                                  <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                                    <mat-form-field class="col-12">
                                      <mat-select placeholder="Business Phone Type" formControlName="phone_type_id">
                                        <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                          {{item.name}}
                                        </mat-option>
                                      </mat-select>
                                      <mat-error
                                        *ngIf="ContactDetails_edit.get('Preitems').controls[i].get('phone_type_id').errors?.required">
                                        Select Phone Type</mat-error>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-sm-2">
                                    <div class="BusAddCnctBtn closep"
                                      *ngIf="ContactDetails_edit.get('Preitems').controls.length > 1">
                                      <button class="addBtn newtrash"
                                        (click)="CloseItem(item,ContactDetails_edit,'Preitems')">
                                        <img src="assets/images/trash.svg">
                                      </button>
                                    </div>
                                    <div class="BusAddCnctBtn"
                                      *ngIf="i == (ContactDetails_edit.get('Preitems').controls.length)-1">
                                      <button class="addBtn" style="padding: 2px 5px !important;"
                                      [disabled]="ContactDetails_edit.get('Preitems')['controls'][i]['value']['phone']?.length!=10 || !ContactDetails_edit.get('Preitems')['controls'][i]['value']['phone_type_id']"
                                        (click)="addItem(ContactDetails_edit,'Preitems')">
                                        <img src="assets/images/add.svg">
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 my-4 text-right">
                        <button class="rounded_yellow_button" mat-flat-button color="primary"
                          (click)="updateBasic()">Update</button>
                      </div>
                    </div>
                    <div class="col-12 mt-4" *ngIf="tabvis_edit==1">
                      <div class="col-12 mt-2">
                        <mat-card class="px-0">
                          <div class="d-flex">
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  Name
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.name}}
                                </span>
                              </div>
                            </div>
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  DBA
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.dba}}
                                </span>
                              </div>
                            </div>
                            <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                              <div class="popupSubTitle_rules">
                                <span>
                                  Cannabis Business Type
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{totalData.license_data?.bp_license_type_name}}
                                </span>
                              </div>
                            </div> -->
                          </div>
                        </mat-card>
                      </div>
                      <!-- <div class="row">

                        <div class="col-12 my-3 p-0 wiz_title">
                          <span class="Badge">{{titleNoEdit.BusinessBankAccountDetails?.slNo}}</span>
                          <span>
                            Business Bank Account Details
                          </span>

                        </div>
                        <div class="col-12 bankqn">
                          <mat-checkbox class="col-12" (change)='updateNeedBankAssistance($event)' [(ngModel)]='need_fin_inst_acc_assis_edit'>I would like
                            assistance in
                            opening a cannabis
                            supported business banking account
                          </mat-checkbox>
                        </div>

                        <div class="col-12 banklist">
                          <div class="row">
                            <div class="col-sm-4 p-0">
                              <form [formGroup]="BankDetails_edit" #BankEdit="ngForm">

                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12">
                                  <mat-form-field class="col-12">
                                    <input matInput  type="text" placeholder="Bank/Account Nickname"
                                      formControlName="business_bank_name">
                                    <mat-error> Enter Bank/Account Nickname </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Routing Number"  type="text" (keypress)="keyPressNumbers($event)" [maxlength]="9"
                                      formControlName="business_bank_routing_number" >
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_routing_number').errors?.required">
                                      Enter a valid Routing Number</mat-error>
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_routing_number').errors?.MaxLength ">
                                      Maximum length of Routing Number should be
                                      {{ BankDetails_edit.get('business_bank_routing_number').errors.MaxLength.requiredLength }}
                                    </mat-error>
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_routing_number').errors?.MinLength">
                                      Minimum length of Routing Number should be
                                      {{ BankDetails_edit.get('business_bank_routing_number').errors.MinLength.requiredLength }}
                                    </mat-error>
                                  </mat-form-field>

                                </div>
                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12">
                                  <mat-form-field class="col-12">
                                    <input matInput [errorStateMatcher]="errorMatcherRouting"  type="text" (keypress)="keyPressNumbers($event)" [maxlength]="9"
                                      (paste)="$event.preventDefault();" placeholder="Re-enter Routing Number"
                                      formControlName="ConfirmBankRoutingNo">
                                    <mat-error *ngIf="BankDetails_edit.hasError('routingNoDoNotMatch')"> Routing Numbers
                                      should be
                                      same
                                    </mat-error>


                                  </mat-form-field>
                                </div>

                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Bank Account Number"  type="text" (keypress)="keyPressNumbers($event)" [maxlength]="20"
                                      formControlName="business_bank_account_number">
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_account_number').errors?.required">
                                      Enter a valid Bank Account Number</mat-error>
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_account_number').errors?.MaxLength ">
                                      Maximum length of Bank Account Number should be
                                      {{ BankDetails_edit.get('business_bank_account_number').errors.MaxLength.requiredLength }}
                                    </mat-error>
                                    <mat-error
                                      *ngIf="BankDetails_edit.get('business_bank_account_number').errors?.MinLength">
                                      Minimum length of Bank Account Number should be
                                      {{ BankDetails_edit.get('business_bank_account_number').errors.MinLength.requiredLength }}
                                    </mat-error>
                                  </mat-form-field>

                                </div>
                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12">
                                  <mat-form-field class="col-12">
                                    <input matInput [errorStateMatcher]="errorMatcherAc"  type="text" (keypress)="keyPressNumbers($event)" [maxlength]="20"
                                      (paste)="$event.preventDefault();" placeholder="Re-enter Bank Account Number"
                                      formControlName="ConfirmBankAcNo">
                                    <mat-error *ngIf="BankDetails_edit.hasError('AcnoDoNotMatch')">Bank Account Numbers
                                      should be
                                      same
                                    </mat-error>

                                  </mat-form-field>
                                </div>

                                <div class="col-sm-12 com-md-12 col-lg-12 col-xl-12 adder">
                                  <button class="rounded_yellow_button" mat-flat-button color="primary"
                                    [disabled]="!BankDetails_edit.valid"
                                    (click)="addBankDetails_edit(BankDetails_edit,'BankDetailsList_edit')">Add</button>
                                </div>
                              </form>
                            </div>
                            <div class="col-sm-8 p-0 ">
                              <div class="iop ">
                                <div class="table-responsive  mat-elevation-z8 striped users_mod">

                                  <table class="col-12" mat-table matSort [dataSource]="BankDetailsList_edit">
                                    <ng-container matColumnDef="Bank Name">
                                      <th class="order_id" mat-header-cell *matHeaderCellDef> Bank/Account Nickname</th>
                                      <td mat-cell *matCellDef="let element"> {{element.business_bank_name}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Routing Number">
                                      <th class="date_width" mat-header-cell *matHeaderCellDef>Routing Number</th>
                                      <td mat-cell *matCellDef="let element"> {{element.business_bank_routing_number }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="A/C Number">
                                      <th class="date_width" mat-header-cell *matHeaderCellDef>A/C Number</th>
                                      <td mat-cell *matCellDef="let element"> {{element.business_bank_account_number}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Status">
                                      <th mat-header-cell *matHeaderCellDef>Status</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{element.fin_financial_inst_bp_status_name}}

                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Action">
                                      <th mat-header-cell *matHeaderCellDef>Action</th>
                                      <td mat-cell *matCellDef="let element">
                                        <div class="action_array">
                                          <button mat-button class="delete"
                                            (click)="deleteBankDetails_edit(element, 'BankDetailsList_edit')">

                                          </button>
                                        </div>

                                      </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="bankDetailEdit;sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: bankDetailEdit;"></tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-8 p-0">
                              <div class="table_outer col-12">
                                <div class="table_header row">
                                  <div class="table_cell col-3">
                                    Bank Name
                                  </div>
                                  <div class="table_cell col-3">
                                    Routing Number
                                  </div>
                                  <div class="table_cell col-3">
                                    A/C Number
                                  </div>
                                  <div class="table_cell col-2 ">
                                    Status
                                  </div>
                                  <div class="table_cell col-1">

                                  </div>
                                </div>
                                <div class="table_details row" *ngFor="let item of BankDetailsList_edit">
                                  <div class="table_cell col-3">
                                    {{item.business_bank_name}}
                                  </div>
                                  <div class="table_cell col-3">
                                    {{item.business_bank_routing_number}}
                                  </div>
                                  <div class="table_cell col-3">
                                    {{item.business_bank_account_number}}
                                  </div>
                                  <div class="table_cell col-2">
                                    {{item.fin_financial_inst_bp_status_name}}
                                  </div>
                                  <div class="table_cell col-1  flex_center bankedits">
                                    <img src="assets/images/dump.svg"
                                      (click)="deleteBankDetails_edit(item, 'BankDetailsList_edit')">
                                  </div>
                                </div>
                              </div>
                               <div class="col-12 text-center" *ngIf="BankDetailsList_edit.length == 0">
                                  <span class="NoDataFound">
                                    No Bank Data Found
                                  </span>
                                </div>
                            </div>
                          </div>
                        </div>

                      </div> -->
                    </div>
                    <div class="col-12 mt-4 " *ngIf="tabvis_edit==2">
                      <div class="col-12 mt-2">
                        <mat-card class="px-0">
                          <div class="d-flex">
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  Name
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.name}}
                                </span>
                              </div>
                            </div>
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  DBA
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.dba}}
                                </span>
                              </div>
                            </div>
                            <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                              <div class="popupSubTitle_rules">
                                <span>
                                  Cannabis Business Type
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{totalData.license_data?.bp_license_type_name}}
                                </span>
                              </div>
                            </div> -->
                          </div>
                        </mat-card>
                      </div>
                      <div class="row ">
                        <div class="col-12 my-3 p-0 wiz_title">
                          <span class="Badge">{{titleNoEdit.KeyPersonRegistration?.slNo - 1}}</span>
                          <span>
                            Key Person Registration
                          </span>
                        </div>
                        <div class="userselection_tabs col-sm-12">
                          <p>Select the type of user to add</p>

                          <div class="col-12 p-0 highres_options">
                            <div class="row">
                              <div class="col-4">
                                <div [ngClass]='{"switch_color":editTab==1}' class="selector" (click)='editTab=1'>
                                  <img *ngIf="editTab!==1" src="assets/images/squareadd.png"><img *ngIf="editTab==1"
                                    src="assets/images/squaretick.png">
                                  <p> BENEFICIAL OWNER (B)</p>
                                </div>
                              </div>
                              <div class="col-5">
                                <div [ngClass]='{"switch_color":editTab==2}' class="selector" (click)='editTab=2'><img
                                    *ngIf="editTab!==2" src="assets/images/squareadd.png"><img *ngIf="editTab==2"
                                    src="assets/images/squaretick.png">
                                  <p>CONTROLLING MANAGERS/OPERATORS (C)</p>
                                </div>
                              </div>
                              <div class="col-3">
                                <div [ngClass]='{"switch_color":editTab==3}' class="selector" (click)='editTab=3'><img
                                    *ngIf="editTab!==3" src="assets/images/squareadd.png"><img *ngIf="editTab==3"
                                    src="assets/images/squaretick.png">
                                  <p>INVESTOR (I)</p>
                                </div>
                              </div>
                              <!-- <div class="col-3">
                                <div [ngClass]='{"switch_color":tab==4}' class="selector" (click)='SetTab(4)'><img
                                    *ngIf="userselect==0&&tab!==4" src="assets/images/squareadd.png"><img
                                    *ngIf="tab==4" src="assets/images/squaretick.png">
                                  <p>CONTACT PERSON</p>
                                </div>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-12" *ngIf='editTab==1'>
                            <form [formGroup]="BeneOwner_edit">
                              <div class="row userform">
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="First Name" formControlName="firstname">
                                    <mat-error *ngIf="BeneOwner_edit.get('firstname').errors?.required" required>Enter
                                      First Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Middle Name" formControlName="middlename">
                                  </mat-form-field>
                                </div> -->
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Last Name" formControlName="lastname" required>
                                    <mat-error *ngIf="BeneOwner_edit.get('lastname').errors?.required">Enter Last Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input type="email" matInput placeholder="Email" formControlName="email" required>
                                    <!-- <mat-error *ngIf="BeneOwner_edit.get('email').errors?.required">Enter Email </mat-error> -->
                                    <mat-error *ngIf="BeneOwner_edit.get('email').errors">Enter a valid Email
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput type='number' placeholder="Percentage Ownership"
                                      formControlName="ownership_percent" min="0" max="100" required>
                                    <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px"
                                      height="14px" matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                                    <mat-error *ngIf="BeneOwner_edit.get('ownership_percent').errors">Enter
                                      Percentage
                                      Ownership (>=20%)</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Access Type" formControlName="role_id" required>
                                      <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="BeneOwner_edit.get('role_id').errors?.required">Select Access Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class='col-12 d-flex'>
                                  <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                                    Does this User has any other roles?
                                  </div>
                                  <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">

                                    <mat-checkbox
                                      (change)='UserControl_edit.BeneOwnerControl=$event.checked;IsValidate($event,BeneOwner_edit,"bp_user_title_id")'
                                      [value]='UserControl_edit.BeneOwnerControl'
                                      [checked]='UserControl_edit.BeneOwnerControl==true'>
                                      Controlling Managers/Operators
                                    </mat-checkbox>
                                  </div>
                                  <div class="col-sm-12 com-md-2 col-lg-4 col-xl-2 extraflds">
                                    <mat-checkbox
                                      (change)='UserControl_edit.BeneOwnerInvestor=$event.checked;IsValidate($event,BeneOwner_edit,"bp_investor_type_id")'
                                      [value]='UserControl_edit.BeneOwnerInvestor'
                                      [checked]='UserControl_edit.BeneOwnerInvestor==true'>
                                      Investor
                                    </mat-checkbox>
                                  </div>

                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.BeneOwnerControl==true'>
                                  <mat-form-field class="col-sm-12">
                                    <input matInput type='text' placeholder="Title"
                                    formControlName="bp_user_title_id">
                                    <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" required>
                                      <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="BeneOwner_edit.get('bp_user_title_id').errors?.required">Select
                                      Title
                                    </mat-error> -->
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.BeneOwnerInvestor==true'>
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                      (selectionChange)="changeInvesterType_edit($event,'BenOwner')" required>
                                      <mat-option *ngFor="let item of investorTypeList"
                                        [value]="item.bp_investor_type_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="BeneOwner_edit.get('bp_investor_type_id').errors?.required">Select
                                      Investor Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group1_edit==1'>
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Investing Group Name"
                                      formControlName="bp_investor_type_comment" required>
                                    <mat-error *ngIf="BeneOwner_edit.get('bp_investor_type_comment').errors?.required">
                                      Enter
                                      Investing
                                      Group Name</mat-error>
                                  </mat-form-field>
                                </div>

                                <div class="col-12 user_edits">
                                  <div class="checkbox">
                                    <mat-checkbox formControlName="is_contact_person">Set as Contact Person
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <button type="button"
                                      (click)='resetRegForm( "group1_edit" ,"editTab",BeneOwner_edit , "UserControl_edit" , "beneOwner")'
                                      class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                      color="primary">Cancel</button>
                                    <button [disabled]="!BeneOwner_edit.valid" type="button"
                                      (click)='addUsers(BeneOwner_edit,"UserControl_edit", "UserList_edit","Edit")'
                                      class="rounded_yellow_button" mat-flat-button color="primary">Add</button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="col-12" *ngIf='editTab==2'>
                            <form [formGroup]="operators_edit">
                              <div class="row userform">
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="First Name" formControlName="firstname" required>
                                    <mat-error *ngIf="operators_edit.get('firstname').errors?.required">Enter First Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Middle Name" formControlName="middlename">
                                  </mat-form-field>
                                </div> -->
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Last Name" formControlName="lastname" required>
                                    <mat-error *ngIf="operators_edit.get('lastname').errors?.required">Enter Last Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input type="email" matInput placeholder="Email" formControlName="email" required>
                                    <mat-error *ngIf="operators_edit.get('email').errors">Enter a valid Email
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <input matInput type='text' placeholder="Title"
                                    formControlName="bp_user_title_id">
                                    <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" required>
                                      <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="operators_edit.get('bp_user_title_id').errors?.required">Select
                                      Title
                                    </mat-error> -->
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Access Type" formControlName="role_id" required>
                                      <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="operators_edit.get('role_id').errors?.required">Select Access Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class='col-12 d-flex'>
                                  <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                                    Does this User has any other roles?
                                  </div>
                                  <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                                    <mat-checkbox
                                      (change)='UserControl_edit.ControlBeneOwner=$event.checked;IsValidate($event,operators_edit,"ownership_percent")'
                                      [value]='UserControl_edit.ControlBeneOwner'
                                      [checked]='UserControl_edit.ControlBeneOwner==true'>
                                      Beneficial Owner
                                    </mat-checkbox>
                                  </div>
                                  <div class="col-sm-12 com-md-2 col-lg-4 col-xl-2 extraflds">
                                    <mat-checkbox
                                      (change)='UserControl_edit.ControlInvestor=$event.checked;IsValidate($event,operators_edit,"bp_investor_type_id")'
                                      [value]='UserControl_edit.ControlInvestor'
                                      [checked]='UserControl_edit.ControlInvestor==true'>
                                      Investor
                                    </mat-checkbox>
                                  </div>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.ControlBeneOwner'>
                                  <mat-form-field class="col-12">
                                    <input matInput type='number' placeholder="Percentage Ownership"
                                      formControlName="ownership_percent" min="0" max="100" required>
                                    <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px"
                                      height="14px" matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                                    <mat-error *ngIf="operators_edit.get('ownership_percent').errors">Enter
                                      Percentage
                                      Ownership (>=20%)</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.ControlInvestor'>
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                      (selectionChange)="changeInvesterType_edit($event,'Operator')" required>
                                      <mat-option *ngFor="let item of investorTypeList"
                                        [value]="item.bp_investor_type_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="operators_edit.get('bp_investor_type_id').errors?.required">Select
                                      Investor Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group2_edit==1'>
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Investing Group Name"
                                      formControlName="bp_investor_type_comment" required>
                                    <mat-error *ngIf="operators_edit.get('bp_investor_type_comment').errors?.required">
                                      Enter
                                      Investing
                                      Group Name</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-12 user_edits">
                                  <div class="checkbox">
                                    <mat-checkbox formControlName="is_contact_person">Set as Contact Person
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <button type="button"
                                      (click)='resetRegForm( "group2_edit" ,"editTab",operators_edit , "UserControl_edit" , "operator")'
                                      class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                      color="primary">Cancel</button>
                                    <button type="button"
                                      (click)='addUsers(operators_edit,"UserControl_edit", "UserList_edit","Edit")'
                                      [disabled]="!operators_edit.valid" class="rounded_yellow_button" mat-flat-button
                                      color="primary">Add</button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="col-12" *ngIf='editTab==3'>
                            <form [formGroup]="investor_edit">
                              <div class="row userform">
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="First Name" formControlName="firstname" required>
                                    <mat-error *ngIf="investor_edit.get('firstname').errors?.required">Enter First Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Middle Name" formControlName="middlename">
                                  </mat-form-field>
                                </div> -->
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Last Name" formControlName="lastname" required>
                                    <mat-error *ngIf="investor_edit.get('lastname').errors?.required">Enter Last Name
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Email" formControlName="email" required>
                                    <mat-error *ngIf="investor_edit.get('email').errors">Enter a valid Email</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                      (selectionChange)="changeInvesterType_edit($event,'Investor')" required>
                                      <mat-option *ngFor="let item of investorTypeList"
                                        [value]="item.bp_investor_type_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="investor_edit.get('bp_investor_type_id').errors?.required">Select
                                      Investor
                                      Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group_edit==1'>
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Investing Group Name"
                                      formControlName="bp_investor_type_comment" required>
                                    <mat-error *ngIf="investor_edit.get('bp_investor_type_comment').errors?.required">
                                      Enter
                                      Investing
                                      Group Name</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Access Type" formControlName="role_id" required>
                                      <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="investor_edit.get('role_id').errors?.required">Select Access Type
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                                <div class='col-12 d-flex'>
                                  <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                                    Does this User has any other roles?
                                  </div>
                                  <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3 extraflds">
                                    <mat-checkbox
                                      (change)='UserControl_edit.InvestBeneOwner=$event.checked;IsValidate($event,investor_edit,"ownership_percent")'
                                      [value]='UserControl_edit.InvestBeneOwner'
                                      [checked]='UserControl_edit.InvestBeneOwner==true'>
                                      Beneficial Owner
                                    </mat-checkbox>
                                  </div>
                                  <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 extraflds">
                                    <mat-checkbox
                                      (change)='UserControl_edit.InvestorControl=$event.checked;IsValidate($event,investor_edit,"bp_user_title_id")'
                                      [value]='UserControl_edit.InvestorControl'
                                      [checked]='UserControl_edit.InvestorControl==true'>
                                      Controlling Managers/Operators
                                    </mat-checkbox>
                                  </div>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.InvestBeneOwner==true'>
                                  <mat-form-field class="col-12">
                                    <input matInput type='number' placeholder="Percentage Ownership"
                                      formControlName="ownership_percent" min="0" max="100" required>
                                    <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px"
                                      height="14px" matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                                    <mat-error *ngIf="investor_edit.get('ownership_percent').errors">Enter
                                      Percentage
                                      Ownership (>=20%)</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                                  *ngIf='UserControl_edit.InvestorControl==true'>
                                  <mat-form-field class="col-sm-12">
                                    <input matInput type='text' placeholder="Title"
                                    formControlName="bp_user_title_id">
                                    <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" required>
                                      <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="investor_edit.get('bp_user_title_id').errors?.required">Select
                                      Title
                                    </mat-error> -->
                                  </mat-form-field>
                                </div>
                                <div class="col-12 user_edits">
                                  <div class="checkbox">
                                    <mat-checkbox formControlName="is_contact_person">Set as Contact Person
                                    </mat-checkbox>
                                  </div>
                                  <div>
                                    <button type="button"
                                      (click)='resetRegForm( "group_edit" ,"editTab",investor_edit , "UserControl_edit" , "investor")'
                                      class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                      color="primary">Cancel</button>
                                    <button [disabled]="!investor_edit.valid" type="button"
                                      (click)='addUsers(investor_edit,"UserControl_edit", "UserList_edit","Edit")'
                                      class="rounded_yellow_button" mat-flat-button color="primary">Add</button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="col-12" *ngIf='editTab==4'>
                            <form [formGroup]="contactPerson_edit">
                              <div class="row userform">
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="First Name" formControlName="firstname">
                                    <mat-error *ngIf="contactPerson_edit.get('firstname').errors?.required">Enter
                                      Contact
                                      Person's
                                      First Name</mat-error>
                                  </mat-form-field>
                                </div>
                                <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Middle Name" formControlName="middlename">
                                  </mat-form-field>
                                </div> -->
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input matInput placeholder="Last Name" formControlName="lastname" required>
                                    <mat-error *ngIf="contactPerson_edit.get('lastname').errors?.required">Enter Contact
                                      Person's
                                      Last
                                      Name</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-12">
                                    <input type='text' matInput placeholder="Phone Number" mask="(000) 000-0000"
                                      [showMaskTyped]="true" formControlName="phonenumber">
                                    <mat-error>Enter a
                                      valid
                                      Contact
                                      Person's Phone Number</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                                  <mat-form-field class="col-sm-12">
                                    <mat-select placeholder="Phone Type" formControlName="phonetype">
                                      <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                        {{item.name}}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="contactPerson_edit.get('phonetype').errors?.required">Enter
                                      Contact
                                      Person's
                                      Phone Type</mat-error>
                                  </mat-form-field>
                                </div>
                                <div class="col-12 user_edits">
                                  <div></div>
                                  <div>
                                    <button type="button" (click)='editTab=0' class="rounded_yellow_button cancel_button  mr-2"
                                      mat-flat-button color="primary">Cancel</button>
                                    <button type="button"
                                      (click)='addUsers(contactPerson_edit,"UserControl_edit", "UserList_edit","Edit")'
                                      [disabled]="!contactPerson_edit.valid" class="rounded_yellow_button"
                                      mat-flat-button color="primary">Add</button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div class="userData">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <!-- <th>Is contact person</th> -->
                                  <th>% of Ownership</th>
                                  <th>Investor Type</th>
                                  <th>Title</th>
                                  <th>Access Type</th>
                                  <th>User Type</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>

                                <tr *ngFor="let item of UserList_edit; let i=index"> 
                                  <td class="contact_person ">
                                    <div class="ph-icon"  *ngIf='item.is_contact_person=="Y"'><img title="Contact Person"  src="assets/images/call.png"></div>
                                    {{item.firstname}} {{item.middlename}} {{item.lastname}}  
                                  </td>
                                  <td>{{item.email}}</td>
                                  <!-- <td>{{item.is_contact_person}}</td> -->
                                  <td>{{item.ownership_percent}}</td>
                                  <!-- <td>{{item.bp_user_title_id |  getname:getInvesterType:'bp_user_title_id'}}</td> -->
                                  <td>{{item.bp_investor_type_id | getname:investorTypeList:'bp_investor_type_id'}}</td>
                                  <!-- <td>{{item.bp_user_title_id | getname:titleList:'bp_user_title_id'}}</td> -->
                                  <td>{{item.bp_user_title_id}}</td>
                                  <td>{{item.role_id | getname:accessTypeList:'um_role_id'}}</td>
                                  <td>
                                    <div class="types_circle d-flex align-items-center">
                                      <span *ngFor='let usid of item.user_associations ; let i=index'>
                                        <span class='Investor'
                                          *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Investor"'>
                                          <div>I</div>
                                        </span>
                                        <span class='controller'
                                          *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Controlling Managers & Operators"'>C</span>
                                        <span class='Bo'
                                          *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Beneficial owner"'>B</span>
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <table class="user_edit_table">
                                      <tbody>
                                        <tr class="user_edit_icons">
                                          <td class="p-0 "><img src="assets/images/pen.svg" alt=""
                                              (click)=" openDialog(item,'UserList_edit',i,'Edit')" class="mr-2"></td>
                                          <td class="p-0" (click)="deleteUser_edit(item,'UserList_edit')"><img
                                              src="assets/images/dump.svg" class="" alt="">
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="row align-items-center ">
                            <div class="col-12 my-3">
                              <div class="dot_ind_legend flex">

                                <div class="flex">
                                  <p class="Bo mb-2 mr-2 legend-line-height">B</p>
                                  <div class="legend-text">Beneficial owner</div>
                                </div>
                                <div class="flex">
                                  <p class="controller mb-2 mr-2 legend-line-height">C
                                  </p>
                                  <div class="legend-text">Controlling Managers & Operators</div>
                                </div>
                                <div class="flex">
                                  <p class="Investor mb-2 mr-2 legend-line-height">I</p>
                                  <div class="legend-text"> Investor</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-12 mt-4 " [ngStyle]="{'display': tabvis_edit==3 ? 'block' : 'none'}">
                      <div class="col-12 mt-2">
                        <mat-card class="px-0">
                          <div class="d-flex">
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  Name
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData['name']}}
                                </span>
                              </div>
                            </div>
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  DBA
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData['dba']}}
                                </span>
                              </div>
                            </div>
                            <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                              <div class="popupSubTitle_rules">
                                <span>
                                  Cannabis Business Type
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{totalData.license_data?.bp_license_type_name}}
                                </span>
                              </div>
                            </div> -->
                          </div>
                        </mat-card>
                      </div>
                      <div class="row">
                        <div class="col-12 my-3 p-0 wiz_title">
                          <span class="Badge">{{titleNoEdit.DeliveryAddress['slNo']-1}}</span>
                          <span>
                            Shipment Delivery Addresses
                          </span>
                        </div>
                        <div class="col-12 p-0">
                          <app-delivery-address [businessInput]="businessInput"></app-delivery-address>
                        </div>

                      </div>
                    </div>
                    <div class="col-12 mt-4 iop " *ngIf="tabvis_edit==4" style="padding-bottom: 20px;">
                      <div class="col-12 mt-2">
                        <mat-card class="px-0">
                          <div class="d-flex">
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  Name
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.name}}
                                </span>
                              </div>
                            </div>
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  DBA
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.dba}}
                                </span>
                              </div>
                            </div>
                            <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                              <div class="popupSubTitle_rules">
                                <span>
                                  Cannabis Business Type
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{totalData.license_data?.bp_license_type_name}}
                                </span>
                              </div>
                            </div> -->
                          </div>
                        </mat-card>
                      </div>

                      <div class="col-12 my-3 p-0 wiz_title">
                        <span class="Badge">{{titleNoEdit.EmailNotificationConfiguration['slNo']-1}}</span>
                        <span>
                          <span class="sub-heading-badge">Email</span> Notification Configuration
                        </span>
                      </div> 
                      <table class="custom_mat_table" *ngIf='notiFTabData'>
                        <tr>
                          <th>Name</th>
                          <th>Email</th> 
                          <th>Access Type</th>
                          <th *ngFor='let item of notifHeaders' class="text-center">{{item['name']}}</th>
                        </tr>
                        <tr *ngFor='let item of userDataforNotif'>
                          <td> {{item.firstname}}
                          </td>
                          <td>{{item['email']}}</td> 
                          <td>{{item['role_id'] | getname:accessTypeList:'um_role_id'}}</td>
                          <td *ngFor='let header of notifHeaders' class="text-center">
                            <mat-checkbox [disabled]='header["is_actionable"] === "N"'
                              [(ngModel)]="item[header['nt_notification_cat_id']]"
                              (change)='changesecurity($event,header,item)'></mat-checkbox>
                          </td>
                        </tr>
                      </table>
 
                      <div class="col-12 my-3 p-0 wiz_title">
                        <span class="Badge">{{titleNoEdit.SMSNotificationConfiguration['slNo']-1}}</span>
                        <span>
                          <span class="sub-heading-badge">SMS</span> Notification Configuration
                        </span>
                      </div> 
                      <span>
                        <table class="custom_mat_table" *ngIf='notiFTabDataSMS'>
                          <tr>
                            <th>Name</th>
                            <th>Mobile Phone</th>
                            <th class="text-center">Opt-In/Out Status</th> 
                            <th>Access Type</th>
                            <th *ngFor='let item of notifHeadersSMS' class="text-center">{{item['name']}}</th>
                          </tr>
                          <tr *ngFor='let item of userDataforNotifSMS'>
                            <td> {{item.firstname}}
                            </td>
                            <td>{{item['phone']}}</td>
                            <td class="text-center">
                              <mat-slide-toggle [checked]="item['notifiction_status']" [disabled]="true">
                              </mat-slide-toggle>
                            </td> 
                            <td>{{item['role_id'] | getname:accessTypeList:'um_role_id'}}</td>
                            <td *ngFor='let header of notifHeadersSMS' class="text-center">
                              <mat-checkbox [disabled]='header["is_actionable"] === "N" || !item["notifiction_status"]'
                                [(ngModel)]="item[header['nt_notification_cat_id']]"
                                (change)='changeSMSNotification($event,header,item)'></mat-checkbox>
                            </td>
                          </tr>
                        </table>
                      </span>
                    </div>
                    <div class="col-12 mt-4" *ngIf="tabvis_edit==5">
                      <div class="col-12 mt-2">
                        <mat-card class="px-0">
                          <div class="d-flex">
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  Name
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.name}}
                                </span>
                              </div>
                            </div>
                            <div class="col">
                              <div class="popupSubTitle_rules">
                                <span>
                                  DBA
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{cloneBusinessData.dba}}
                                </span>
                              </div>
                            </div>
                            <!-- <div class="col" *ngIf='cloneBusinessData["is_cannabis_business"]=="Y"'>
                              <div class="popupSubTitle_rules">
                                <span>
                                  Cannabis Business Type
                                </span>
                              </div>
                              <div class="blueFont">
                                <span>
                                  {{totalData.license_data?.bp_license_type_name}}
                                </span>
                              </div>
                            </div> -->
                          </div>
                        </mat-card>
                      </div>
                      <div class="col-12 my-3 p-0 wiz_title">
                        <span class="Badge">{{titleNoEdit.fileManagement['slNo']-1}}</span>
                        <span> File Management </span>
                      </div>
                      <div class="row m-0">
                        <div class="col-12 p-0">
                          <ul class="nav nav-tabs new-tabs" role="tablist">
                            <li class="nav-item pointer">
                              <a class="nav-link" [ngClass]="{'active':fileManagementTabs == 0}" (click)="fileManagementTabs = 0">My Files</a>
                            </li>
                            <li class="nav-item pointer">
                              <a class="nav-link" [ngClass]="{'active':fileManagementTabs == 1}" (click)="fileManagementTabs = 1">Shared With Me</a>
                            </li>
                            <li class="nav-item pointer">
                              <a class="nav-link" [ngClass]="{'active':fileManagementTabs == 2}" (click)="fileManagementTabs = 2">Sharing Groups</a>
                            </li>
                          </ul>
                        </div>

                        <div class="col-12" *ngIf="fileManagementTabs==0">
                          <div class="row">
                            <div class="doc_head_wrap">

                              <div class="d-flex flex-wrap end-center">
                                <div class="search_top">
                                  <div class="my-1">
                                    <div class="srchGroup">
                                      <div class="srchIcon" (click)='SearchDocuments()'>
                                        <img src="assets/images/search.svg">
                                      </div>
                                      <div class="srchTextbox">
                                        <input type="text" placeholder="Search Files" [(ngModel)]='docSearchInput'
                                        (blur)='SearchDocuments()'  (keyup.enter)='SearchDocuments()'>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="my-1 cmn_mar mr-1">
                                  <button class="mat-primaryCus" style="margin-right: 15px;" mat-raised-button (click)="showAllFiles()">Show All</button>
                                  <button class="mat-primaryCus" mat-raised-button
                                    [matMenuTriggerFor]="addFileMenu" [disabled]="crumCode=='' || docSearchInput == '%'">Add New</button>
                                  <mat-menu #addFileMenu="matMenu">
                                  
                                    <button mat-menu-item (click)='openFolderDialogs()'>
                                      <span>Add Folder</span>
                                    </button>
                                    <button mat-menu-item (click)='openFilesDialogs()'>
                                      <span>Add Files</span>
                                    </button>
                                  </mat-menu>
                                </div>
                                <div class="my-1 cmn_mar mr-1">
                                  <button mat-raised-button (click)='downloadMultipleDocs()'
                                  [disabled]="selectionDocs.selected.length == 0 && !pdfPreview"> Download </button>
                                </div>
                                <div class="my-1 cmn_mar mr-1">
                                  <button mat-raised-button (click)='MoveMultipleDocs()'
                                  [disabled]="selectionDocs.selected.length == 0 && !pdfPreview"> Move </button>
                                </div>
                                <div class="mr-1 my-1 list_grid_button" (click)="refreshDoc()">
                                  <img src="/assets/images/refresh.svg">
                                </div>
                                <div class="mr-1 my-1 list_grid_button"
                                  (click)="toggleGrid()">
                                  <img *ngIf="!displayedColumns4ListView" src="assets/images/list_view.png">
                                  <img *ngIf="displayedColumns4ListView" src="assets/images/grid_view.png">
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="crums my-1">
                                <ul *ngIf="!pdfPreview" class="00000">
                                  <li class="upOne noCursor"><img src="/assets/images/upOne.svg"></li>
                                  <li> <img src="assets/images/home.png"></li>
                                </ul>
                                <ul *ngIf="pdfPreview">
                                  <li class="upOne"><img (click)="upOneFolder()" src="/assets/images/upOne.svg"></li>
                                  <li><img (click)="crumSwitch('Home')" src="assets/images/home.png"></li>
                                  <li>
                                    <div class="arrow">></div>
                                    <div class="crum-txt" (click)="backToParent()">{{parentCrum.name}}</div>
                                  </li>
                                  <li *ngFor="let item of crum.slice().reverse()">
                                    <div class="arrow">></div>
                                    <div class="crum-txt" (click)="backTofolder(item)">{{item?.attachment_name}}</div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="col-12 p-0">
                              <ng-container *ngIf="displayedColumns4ListView; else elseTemplate">
                                  <div class="table_Cover" *ngIf="!pdfPreview">
                                    <table mat-table [dataSource]="folderDocs" class="border-b fixed_layout striped">
                                    <ng-container matColumnDef="Name">
                                      <th mat-header-cell *matHeaderCellDef class="cell">File Class</th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                        <img class="td_img" src="assets/images/folder.png">
                                        <span class="el_label">
                                          {{element.name}} <label>{{element.count}} item(s)</label>
                                        </span>
                                      </td>

                                    </ng-container>
                                    <ng-container matColumnDef="Size">
                                      <th mat-header-cell class="cell" *matHeaderCellDef>Updated By </th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                        {{element['um_user.firstname']?element['um_user.firstname']:''}}
                                        {{element['um_user.middlename']?element['um_user.middlename']:''}}
                                        {{element['um_user.lastname']?element['um_user.lastname']:''}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Date">
                                      <th mat-header-cell class="cell cellr" *matHeaderCellDef>Updated Date</th>
                                      <td mat-cell class="cell cellr" *matCellDef="let element">
                                        <span
                                          *ngIf="element.updated_at">{{element.updated_at | date : 'medium'}}</span>
                                        <span *ngIf="!element.updated_at">-</span>
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Action">
                                      <th class="action_head" class="cell celll" mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell class="cell celll" *matCellDef="let element">
                                        <div class="action_array">
                                          <button mat-icon-button (click)='$event.stopPropagation()' [matMenuTriggerFor]="menuView">
                                            <mat-icon>more_vert</mat-icon>
                                          </button>
                                          <mat-menu #menuView="matMenu">
                                            <button mat-menu-item 
                                              (click)="mainHistory(element);">
                                              <span><img class="h-icon" src="assets/images/file-log.png"> History</span>
                                            </button>
                                          </mat-menu>
                                        </div>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns4Parent"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns4Parent;"
                                      (click)="getAllBusinessDocs($event,row,{page:1})"></tr>
                                  </table>
                                  <div class="col-12 bgWhite"  *ngIf="folderDocs.length > 0">
                                    <div class="row align-items-center ">
                                      <div class="col-12">
                                        <mat-paginator [pageSizeOptions]="folderPage.pageSizeOptions" [length]="folderPage.limit"
                                          [pageSize]="folderPage.pageSize" (page)="folderPageChange($event)" [pageIndex]="folderPage.index"
                                          showFirstLastButtons></mat-paginator>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="table_Cover" *ngIf="pdfPreview">
                                  <table mat-table [dataSource]="subDocs" matSort (matSortChange)="sortData($event)"
                                    class="border-b fixed_layout striped">
                                    <ng-container matColumnDef="Select" sticky>
                                      <th class="checkbox_width text-center cell cellr" mat-header-cell *matHeaderCellDef>
                                        <mat-checkbox (change)="$event ? masterToggleDocs() : null"
                                          [checked]="selectionDocs.hasValue() && isAllSelectedDocs()"
                                          [indeterminate]="selectionDocs.hasValue() && !isAllSelectedDocs()">
                                        </mat-checkbox>
                                      </th>
                                      <td class="checkbox_width text-center cell cellr" mat-cell *matCellDef="let row">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                          (change)="row.checkbox = $event.checked;$event ? selectionDocs.toggle(row) : null"
                                          [checked]="selectionDocs.isSelected(row)">
                                        </mat-checkbox>
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="attachment_name">
                                      <th mat-header-cell class="cell celll" *matHeaderCellDef mat-sort-header>Name</th>
                                      <td mat-cell class="cell celll" *matCellDef="let element">
                                        <section class="td_flex">
                                          <ng-container *ngIf="element.is_folder=='Y'; else elseTemplate">
                                            <img class="td_img" src="assets/images/folder.png">
                                          </ng-container>
                                          <ng-template #elseTemplate>
                                            <img class="td_img" src="assets/images/files.svg">
                                          </ng-template>
                                          <span class="el_label">
                                            {{element?.attachment_name}} 
                                            <img class="shared-icon" *ngIf="element.share_count!='0'" src="assets/images/shared.svg">
                                            <label *ngIf="element.is_folder=='Y'">{{element.document_count}} item(s)</label> <label *ngIf="element.is_pii=='Y'" class="pii_badge">PII</label><br>
                                            <label *ngIf="isSearch" class="folder_path">{{element.document_path}}</label>
                                          </span>
                                          <img class="virus-icon" title="Potential malware detected" *ngIf="element.av_overall_infected === 'Y'" src="assets/images/file-virus.png">
                                        </section>
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="bp_business_name">
                                      <th mat-header-cell class="cell" *matHeaderCellDef mat-sort-header>Business Name </th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                         {{element['bp_business.created_business_name']?element['bp_business.created_business_name']:'StandardC'}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="bp_doc_type_name">
                                      <th mat-header-cell class="cell" *matHeaderCellDef mat-sort-header>File Type </th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                        {{element['v_bp_doc_type.name']}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="updatedby">
                                      <th mat-header-cell class="cell" *matHeaderCellDef mat-sort-header>Updated By</th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                        {{element['um_user.firstname']?element['um_user.firstname']:''}}
                                        {{element['um_user.middlename']?element['um_user.middlename']:''}}
                                        {{element['um_user.lastname']?element['um_user.lastname']:''}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="updated">
                                      <th mat-header-cell class="cell" mat-sort-header *matHeaderCellDef>Updated Date 1</th>
                                      <td mat-cell class="cell" *matCellDef="let element">
                                        <span *ngIf="element.updated">{{element.updated | date : 'medium'}}</span>
                                        <span *ngIf="!element.updated">-</span>
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Action">
                                      <th class="action_head" class="cell" mat-header-cell *matHeaderCellDef></th>
                                      <td mat-cell class="cell" *matCellDef="let element; let i=index">
                                        <div class="action_array"> 
                                          <button mat-icon-button (click)='$event.stopPropagation()'
                                            [matMenuTriggerFor]="menuView">
                                            <mat-icon>more_vert</mat-icon>
                                          </button>
                                          <mat-menu #menuView="matMenu">
                                            <app-file-menu [item]="element" [businessId]="cloneBusinessData['bp_business_id']" [parentCrum]="parentCrum.name" (fileMenuClick)="menuClick($event,i)"></app-file-menu>
                                          </mat-menu>
                                        </div>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns4"></tr>
                                    <tr mat-row matTooltip = "{{row.doc_comment}}" *matRowDef="let row; columns: displayedColumns4;"
                                      (click)="getBusinessSubDocs($event,row)"></tr>
                                  </table>
                                  <span class="NoDataFound" *ngIf="subDocs.length == 0">
                                    No Data Found
                                  </span>
                                  <div class="col-12 bgWhite"  *ngIf="subDocs.length > 0">
                                    <div class="row align-items-center ">
                                      <div class="col-12">
                                        <mat-paginator [pageSizeOptions]="filePage.pageSizeOptions" [length]="filePage.limit"
                                          [pageSize]="filePage.pageSize" (page)="filePageChange($event)" [pageIndex]="filePage.index"
                                          showFirstLastButtons></mat-paginator>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #elseTemplate>
                                <div *ngIf="!pdfPreview">
                                  <div class="doc_grid_outer">
                                    <mat-card class="doc_grid_card" *ngFor="let item of folderDocs"
                                      (click)="getAllBusinessDocsDetails(item,{page:1})">
                                      <div class="pdf folder_ico">
                                        <img src="/assets/images/folder.svg">
                                      </div>
                                      <div class="pdf-overlay"></div>
                                      <div class="pdf-footer">
                                        <section>
                                          <div class="pdf-h">{{item.name}}</div>
                                          <div class="pdf-p">Updated on {{item.updated_at | date : 'medium'}}</div>
                                        </section>
                                        <div class="actionCol action_array">
                                        </div>
                                      </div>
                                    </mat-card>
                                    <div class="col-12 bgWhite"  *ngIf="folderDocs.length > 0">
                                      <div class="row align-items-center ">
                                        <div class="col-12">
                                          <mat-paginator [pageSizeOptions]="folderPage.pageSizeOptions" [length]="folderPage.limit"
                                            [pageSize]="folderPage.pageSize" (page)="folderPageChange($event)" [pageIndex]="folderPage.index"
                                            showFirstLastButtons></mat-paginator>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="doc_grid_outer" *ngIf="pdfPreview">
                                  <mat-card class="doc_grid_card" (click)="getBusinessSubDocsDetails(item)"
                                    *ngFor="let item of subDocs; let i=index">
                                    <ng-container *ngIf="item.is_folder!='Y'; else elseTemplate">
                                      <div class="pdf">
                                        <ng-container *ngIf="item?.docType=='image'; else elseTemplate">
                                          <img *ngIf="item?.docUrl" [src]="item?.docUrl | safe" />
                                          <img *ngIf="!item?.docUrl" src="/assets/images/image_load.svg" />
                                        </ng-container>
                                        <ng-template #elseTemplate>
                                          <img src="/assets/images/docs.svg">
                                        </ng-template>
                                      </div>
                                      <div class="pdf-overlay"></div>
                                      <div class="pdf-footer">
                                        <section>
                                          <div class="d-flex">
                                            <div class="pdf-ellipsis">{{item.attachment_name}}</div>
                                            <img class="shared-icon" *ngIf="item.share_count!='0'" src="assets/images/shared.svg">
                                          </div> 
                                          <div class="pdf-p">Last Update on {{item.updated | date : 'medium'}}</div>
                                        </section>
                                        <div class="actionCol action_array">
                                          <button mat-icon-button (click)='$event.stopPropagation()'
                                            [matMenuTriggerFor]="menuView">
                                            <mat-icon>more_vert</mat-icon>
                                          </button>
                                          <mat-menu #menuView="matMenu">
                                            <app-file-menu [item]="item" [businessId]="cloneBusinessData['bp_business_id']" [parentCrum]="parentCrum.name" (fileMenuClick)="menuClick($event,i)"></app-file-menu>
                                          </mat-menu>
                                        </div>
                                      </div>
                                    </ng-container>
                                    <ng-template #elseTemplate>
                                      <div class="pdf folder_ico">
                                        <img src="/assets/images/folder.svg">
                                      </div>
                                      <div class="pdf-overlay"></div>
                                      <div class="pdf-footer">
                                        <section>
                                          <div class="d-flex">
                                            <div class="pdf-ellipsis">{{item.attachment_name}}</div>
                                            <img class="shared-icon" *ngIf="item.share_count!='0'" src="assets/images/shared.svg">
                                          </div> 
                                          <div class="pdf-p">Last Update on {{item.updated | date : 'medium'}}</div>
                                        </section>
                                        <div class="action_array">
                                          <button mat-icon-button (click)='$event.stopPropagation()'
                                            [matMenuTriggerFor]="menuView">
                                            <mat-icon>more_vert</mat-icon>
                                          </button>
                                          <mat-menu #menuView="matMenu">
                                            <app-file-menu [item]="item" [businessId]="cloneBusinessData['bp_business_id']" [parentCrum]="parentCrum.name" (fileMenuClick)="menuClick($event,i)"></app-file-menu>
                                          </mat-menu>
                                        </div>
                                      </div>
                                    </ng-template>
                                  </mat-card>
                                  <span class="NoDataFound" *ngIf="subDocs.length == 0">
                                    No Data Found
                                  </span>
                                  <div class="col-12 bgWhite"  *ngIf="subDocs.length > 0">
                                    <div class="row align-items-center ">
                                      <div class="col-12">
                                        <mat-paginator [pageSizeOptions]="filePage.pageSizeOptions" [length]="filePage.limit"
                                          [pageSize]="filePage.pageSize" (page)="filePageChange($event)" [pageIndex]="filePage.index"
                                          showFirstLastButtons></mat-paginator>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>




                        <div class="col-12 mt-4 iop" *ngIf="fileManagementTabs==1">
                          <div class="row d-flex file-nav">
                           <div class="col-6">
                             <div class="crums my-1">
                               <ul *ngIf="!pdfPreviewSharedWithMe">
                                 <li> <img (click)="crumSwitchSharedWithMe('Home')" src="assets/images/home.png"></li>
                               </ul>
                               <ul *ngIf="pdfPreviewSharedWithMe">
                                 <li class="upOne"><img (click)="upOneFolderSharedWithMe()" src="/assets/images/upOne.svg"></li>
                                 <li> <img (click)="crumSwitchSharedWithMe('Home')" src="assets/images/home.png"></li>
                                 <li>
                                   <div class="arrow">></div>
                                   <div class="crum-txt" (click)="backToParentSharedWtihMe()">{{parentCrumSharedWithMe.name}}</div>
                                 </li>
                                 <li *ngFor="let item of crumSharedWithMe.slice().reverse()">
                                   <div class="arrow">></div>
                                   <div class="crum-txt" (click)="backTofolderSharedWithMe(item)">{{item.attachment_name}}</div>
                                 </li>
                               </ul>
                             </div>
                           </div>
                           <div class="doc_head_wrap end-center col-6">

                             <div class="d-flex justify-content-between flex-wrap">
                               <div class="search_top" *ngIf="pdfPreviewSharedWithMe && crumSharedWithMe.length == 0">
                                 <div class="my-1">
                                   <div class="srchGroup">
                                     <div class="srchIcon" (click)='getAllSharedWithMeDocs(selectedSharedWithMe, {page : 1})'>
                                       <img src="assets/images/search.svg">
                                     </div>
                                     <div class="srchTextbox">
                                       <input type="text" placeholder="Search Files" [(ngModel)]='docSearchInputSharedWithMe'
                                         (keyup.enter)='getAllSharedWithMeDocs(selectedSharedWithMe, {page : 1})'>
                                     </div>
                                   </div>
                                 </div>
                               </div>

                                 <div class="search_top" *ngIf="!parentCrumSharedWithMe.name" >
                                   <div class="my-1">
                                     <div class="srchGroup">
                                       <div class="srchIcon" (click)='getSharedWithMe(editBusinessID,"new",{ page: 1 })'>
                                         <img src="assets/images/search.svg">
                                       </div>
                                       <div class="srchTextbox">
                                         <input type="text" placeholder="Search Business" [(ngModel)]='businessSearchInput'
                                           (keyup.enter)='getSharedWithMe(editBusinessID,"new",{ page: 1 })'>
                                       </div>
                                     </div>
                                   </div>
                                 </div>


                               <div class="my-1 cmn_mar mr-1">
                                 <button mat-raised-button (click)='downloadMultipleDocsSharedWithMe()'
                                   [disabled]="selectionDocsSharedWithMe.selected.length == 0 && !pdfPreviewSharedWithMe"> Download
                                   ({{selectionDocsSharedWithMe.selected.length}}) </button>
                               </div>
                               <div class="mr-1 my-1 list_grid_button" (click)="toggleGridSharedWithMe()">
                                 <img *ngIf="!displayedColumns4ListViewSharedWithMe" src="assets/images/list_view.png">
                                 <img *ngIf="displayedColumns4ListViewSharedWithMe" src="assets/images/grid_view.png">
                               </div>

                             </div>
                           </div>




                           <div class="col-12 p-0">
                             <ng-container *ngIf="displayedColumns4ListViewSharedWithMe; else elseTemplate">
                               <div class="table_Cover" *ngIf="!pdfPreviewSharedWithMe">
                                 <table mat-table [dataSource]="sharedWithMeList" class="border-b fixed_layout striped">
                                   <ng-container matColumnDef="Name">
                                     <th mat-header-cell *matHeaderCellDef>Business Name</th>
                                     <td mat-cell *matCellDef="let element">
                                       <img class="td_img" src="assets/images/folder.png">
                                       <span class="el_label">
                                        {{element.bp_business.name}} <label>{{element.count}} item(s)</label>
                                      </span></td>
                                   </ng-container>
                                   <ng-container matColumnDef="Size">
                                     <th mat-header-cell *matHeaderCellDef>Count </th>
                                     <td mat-cell *matCellDef="let element"> {{element.count>0?element.count:'-'}}</td>
                                   </ng-container>
                                   <tr mat-header-row *matHeaderRowDef="displayedColumns4ParentSharedWithMe"></tr>
                                   <tr mat-row *matRowDef="let row; columns: displayedColumns4ParentSharedWithMe;"
                                     (click)="getAllSharedWithMeDocs(row, { page : 1 })"></tr>
                                 </table>

                                 <div class="col-12 bgWhite"  *ngIf="sharedWithMeList.length > 0">
                                   <div class="row align-items-center ">
                                     <div class="col-12">
                                       <mat-paginator style="height: 60px !important;" [pageSizeOptions]="shareWithMefolderPage.pageSizeOptions" [length]="shareWithMefolderPage.limit"
                                         [pageSize]="shareWithMefolderPage.pageSize" (page)="shareWithMefolderPageChange($event)" [pageIndex]="shareWithMefolderPage.index"
                                         showFirstLastButtons></mat-paginator>
                                     </div>
                                   </div>
                                 </div>

                                 <span class="NoDataFound" *ngIf="sharedWithMeList.length == 0">
                                   No Data Found
                                 </span>
                               </div>
                               <div class="table_Cover" *ngIf="pdfPreviewSharedWithMe">
                                 <table mat-table [dataSource]="subDocsSharedWithMe" matSort
                                   class="border-b fixed_layout striped">
                                   <ng-container matColumnDef="Select" sticky>
                                     <th class="checkbox_width text-center" mat-header-cell *matHeaderCellDef>
                                       <mat-checkbox (change)="$event ? masterToggleDocsSharedWithMe() : null"
                                         [checked]="selectionDocsSharedWithMe.hasValue() && isAllSelectedDocsSharedWithMe()"
                                         [indeterminate]="selectionDocsSharedWithMe.hasValue() && !isAllSelectedDocsSharedWithMe()">
                                       </mat-checkbox>
                                     </th>
                                     <td class="checkbox_width text-center" mat-cell *matCellDef="let row">
                                       <mat-checkbox (click)="$event.stopPropagation()"
                                         [disabled]="row.av_overall_infected === 'Y'"
                                         (change)="row.checkbox = $event.checked;$event ? selectionDocsSharedWithMe.toggle(row) : null"
                                         [checked]="selectionDocsSharedWithMe.isSelected(row)">
                                       </mat-checkbox>
                                     </td>
                                   </ng-container>
                                   <ng-container matColumnDef="attachment_name">
                                     <th mat-header-cell *matHeaderCellDef>Name</th>
                                     <td mat-cell *matCellDef="let element">
                                       <section class="td_flex">
                                         <ng-container *ngIf="element.is_folder=='Y'; else elseTemplate">
                                           <img class="td_img" src="assets/images/folder.png">
                                         </ng-container>
                                         <ng-template #elseTemplate>
                                           <img class="td_img" src="assets/images/files.svg">
                                         </ng-template>
                                         <span class="el_label">
                                          {{element.attachment_name}} <label
                                            *ngIf="element.is_folder=='Y'">{{element.document_count}} item(s)</label>
                                            <label *ngIf="element.is_pii=='Y'" class="pii_badge">PII</label><br>
                                        </span>
                                        <img class="virus-icon" title="Potential malware detected" *ngIf="element.av_overall_infected === 'Y'" src="assets/images/file-virus.png">
                                       </section>
                                     </td>
                                   </ng-container>
                                   <ng-container matColumnDef="Size">
                                     <th mat-header-cell *matHeaderCellDef>Count </th>
                                     <td mat-cell *matCellDef="let element"> -</td>
                                   </ng-container>
                                   <ng-container matColumnDef="User">
                                     <th mat-header-cell *matHeaderCellDef>Created By</th>
                                     <td mat-cell *matCellDef="let element">
                                       <span>{{ element.um_user.firstname +' '+ element.um_user.middlename +' '+ element.um_user.lastname }}</span>
                                       </td>
                                   </ng-container>
                                   <ng-container matColumnDef="Date">
                                     <th mat-header-cell *matHeaderCellDef>Updated Date</th>
                                     <td mat-cell *matCellDef="let element">
                                       <span *ngIf="element.updated">{{element.updated | date : 'medium'}}</span>
                                       <span *ngIf="!element.updated">-</span>
                                     </td>
                                   </ng-container>
                                   <ng-container matColumnDef="Action">
                                     <th class="action_head" mat-header-cell *matHeaderCellDef></th>
                                     <td mat-cell *matCellDef="let element">
                                       <div class="action_array" style="width: 100% !important; height: 100% !important">
                                         <ng-container>
                                           <button mat-button class="view"
                                             [disabled]="element.av_overall_infected === 'Y'"
                                             (click)='$event.stopPropagation(); viewDocSharedWithMe(element)' title="View"></button>
                                           <button mat-button class="download"
                                             [disabled]="element.av_overall_infected === 'Y'"
                                             (click)='$event.stopPropagation();downLoadFileAPI([element.bp_document_id])'
                                             title="Download"></button>
                                           </ng-container>
                                       </div>
                                     </td>
                                   </ng-container>
                                   <tr mat-header-row *matHeaderRowDef="displayedColumns4SharedWithMe"></tr>
                                   <tr mat-row matTooltip = "{{row.doc_comment}}" *matRowDef="let row; columns: displayedColumns4SharedWithMe;"
                                     (click)="getBusinessSubDocsSharedWithMe(row)"></tr>
                                 </table>

                                 <div class="col-12 bgWhite"  *ngIf="subDocsSharedWithMe?.length > 0">
                                   <div class="row align-items-center ">
                                     <div class="col-12">
                                       <mat-paginator style="height: 60px !important;" [pageSizeOptions]="shareWithMeSubfolderPage.pageSizeOptions" [length]="shareWithMeSubfolderPage.limit"
                                         [pageSize]="shareWithMeSubfolderPage.pageSize" (page)="shareWithMeSubfolderPageChange($event)" [pageIndex]="shareWithMeSubfolderPage.index"
                                         showFirstLastButtons></mat-paginator>
                                     </div>
                                   </div>
                                 </div>

                                 <span class="NoDataFound" *ngIf="subDocsSharedWithMe?.length == 0">
                                   No Data Found
                                 </span>
                               </div>
                             </ng-container>
                             <ng-template #elseTemplate>
                               <div *ngIf="!pdfPreviewSharedWithMe">
                                 <div class="doc_grid_outer">
                                   <mat-card class="doc_grid_card" *ngFor="let item of sharedWithMeList"
                                     (click)="getAllSharedWithMeDocs(item, {page : 1})">

                                     <div class="pdf folder_ico">
                                       <img src="/assets/images/folder.svg">
                                     </div>
                                     <div class="pdf-overlay"></div>
                                     <div class="pdf-footer">
                                       <section>
                                         <div class="pdf-h">{{item.bp_business.name}}</div>
                                         <div class="pdf-p">Count: {{item.count> 0 ? item.count:'-'}}</div>
                                       </section>
                                     </div>
                                   </mat-card>
                                 </div>
                               </div>
                               <div class="doc_grid_outer" *ngIf="pdfPreviewSharedWithMe">
                                 <mat-card class="doc_grid_card" (click)="getBusinessSubDocsSharedWithMe(item)"
                                   *ngFor="let item of subDocsSharedWithMe">
                                   <ng-container *ngIf="item.is_folder!='Y'; else elseTemplate">
                                     <div class="pdf">
                                       <ng-container *ngIf="item?.docType=='image'; else elseTemplate">
                                         <img *ngIf="item?.docUrl" [src]="item?.docUrl | safe" />
                                         <img *ngIf="!item?.docUrl" src="/assets/images/image_load.svg" />
                                       </ng-container>
                                       <ng-template #elseTemplate>
                                         <img src="/assets/images/docs.svg">
                                       </ng-template>
                                     </div>
                                     <div class="pdf-overlay"></div>
                                     <div class="pdf-footer">
                                       <section>
                                         <div class="pdf-h">{{item.attachment_name}}</div>
                                         <div class="pdf-p">{{item.updated | date : 'medium'}}</div>
                                       </section>
                                       <div class="actionCol action_array" style="width: 100% !important; height: 100% !important"> 
                                         <button mat-icon-button (click)='$event.stopPropagation()'
                                           [matMenuTriggerFor]="menuView">
                                           <mat-icon>more_vert</mat-icon>
                                         </button>
                                         <mat-menu #menuView="matMenu">
                                           <button mat-menu-item [disabled]="item.av_overall_infected === 'Y'" (click)='viewDocSharedWithMe(item)'>
                                             <span>View</span>
                                           </button>
                                           <button mat-menu-item [disabled]="item.av_overall_infected === 'Y'" (click)='downLoadFileAPI([item.bp_document_id])'>
                                             <span>Download</span>
                                           </button>
                                           <button mat-menu-item *ngIf='item.isactive=== "Y"'
                                             (click)='verifyDelete(item);'>
                                             <span>Delete</span>
                                           </button>
                                         </mat-menu>
                                       </div>
                                     </div>
                                   </ng-container>
                                   <ng-template #elseTemplate>
                                     <div class="pdf folder_ico">
                                       <img src="/assets/images/folder.svg">
                                     </div>
                                     <div class="pdf-overlay"></div>
                                     <div class="pdf-footer">
                                       <section>
                                         <div class="pdf-h">{{item.attachment_name}}</div>
                                         <div class="pdf-p">{{item.updated | date : 'medium'}}</div>
                                       </section>
                                       <div class="action_array" style="width: 100% !important; height: 100% !important">
                                         <button mat-icon-button (click)='$event.stopPropagation()'
                                           [matMenuTriggerFor]="menuView">
                                           <mat-icon>more_vert</mat-icon>
                                         </button>
                                         <mat-menu #menuView="matMenu">
                                           <button mat-menu-item [disabled]="item.av_overall_infected === 'Y'" (click)='viewDocSharedWithMe(item)'>
                                             <span>View</span>
                                           </button>
                                           <button mat-menu-item [disabled]="item.av_overall_infected === 'Y'" (click)='downLoadFileAPI([item.bp_document_id])'>
                                             <span>Download</span>
                                           </button>
                                           <button mat-menu-item *ngIf='item.isactive=== "Y"'
                                             (click)='verifyDelete(item);'>
                                             <span>Delete</span>
                                           </button>
                                         </mat-menu>
                                       </div>
                                     </div>
                                   </ng-template>
                                 </mat-card>
                                 <span class="NoDataFound" *ngIf="subDocsSharedWithMe.length == 0">
                                   No Data Found
                                 </span>
                               </div>
                             </ng-template>
                           </div>
                         </div>
                       </div>
                       <div class="col-12 mt-4 iop " *ngIf="fileManagementTabs==2 ">
                        <div class="col-12 d-flex justify-content-end align-items-center">
                          <div class="search_top" *ngIf="sharingFilesIndex === 0" >
                            <div class="my-1">
                              <div class="srchGroup">
                                <div class="srchIcon" (click)='getSharingGroup(editBusinessID,"new",{ page: 1 })'>
                                  <img src="assets/images/search.svg">
                                </div>
                                <div class="srchTextbox">
                                  <input type="text" placeholder="Search Group" [(ngModel)]='groupSearchInput'
                                    (keyup.enter)='getSharingGroup(editBusinessID,"new",{ page: 1 })'>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class=" text-right my-3">
                          <button mat-button class="btnBack mr-1 absolute_back_button" *ngIf="sharingFilesIndex ===  1" (click)="sharingFilesIndex = 0">Back</button>
                          <button mat-raised-button color="primaryCus" *ngIf="sharingFilesIndex === 0" (click)="addGroup()">Add Group</button>
                          <button mat-raised-button color="primaryCus" *ngIf="sharingFilesIndex === 1" (click)="addBusiness(selectedBusiness)">Add Business</button>
                          </div>
                        </div>
                        <mat-tab-group [(selectedIndex)]="sharingFilesIndex">
                        <mat-tab>
                        <div class='col-12 my-4'>
                          <mat-card class="p-0">
                            <div class="mat-elevation-z8 checkBoxlign ">
                              <div class="table_Cover">
                                <table class="border-b fixed_layout striped" mat-table [dataSource]="sharingGroupList">
                                  <ng-container matColumnDef="Name">
                                    <th mat-header-cell *matHeaderCellDef>Name</th>
                                    <td mat-cell *matCellDef="let element">
                                      <div class="d-flex justify-content-between align-items-center"
                                      matTooltip="{{element.name}}"
                                      [matTooltipDisabled]="element?.name?.length < 22">
                                      <p style="margin: 0 !important;" class="grp-desc">{{element.name}}</p>
                                      <div (click)="copyGroup($event, element)"><img class="copy"
                                          src="../../../assets/images/copy.svg"></div>
                                    </div>
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="Description">
                                    <th mat-header-cell *matHeaderCellDef>Description</th>
                                    <td mat-cell *matCellDef="let element">
                                      <div class="d-flex justify-content-between align-items-center"
                                        matTooltip="{{element.description}}"
                                        [matTooltipDisabled]="element?.description?.length < 25">
                                        <p class="grp-desc">
                                          {{element.description}}</p>
                                      </div>
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="No of Business">
                                    <th mat-header-cell *matHeaderCellDef class="w-120px">No of Business</th>
                                    <td mat-cell *matCellDef="let element" class="w-120px">
                                      {{element.bp_document_access_group_bizs.length}}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="Created By">
                                    <th mat-header-cell *matHeaderCellDef>Created By</th>
                                    <td mat-cell *matCellDef="let element">
                                      {{ element?.um_user?.firstname +' '+ element?.um_user?.middlename +' '+ element?.um_user?.lastname }}
                                    </td>
                                  </ng-container>
                                  <ng-container matColumnDef="Created Date">
                                    <th mat-header-cell *matHeaderCellDef>Created Date</th>
                                    <td mat-cell *matCellDef="let element">
                                      {{element.updated | date : 'MMM dd, yyyy, hh:mm:ss a'}} </td>
                                  </ng-container>
                                  <ng-container matColumnDef="Action">
                                    <th class="checkbox_width" mat-header-cell *matHeaderCellDef> </th>
                                    <td class="checkbox_width" mat-cell *matCellDef="let element">
                                      <mat-icon class="pointer" #tableMenuTrigger="matMenuTrigger"
                                        (click)='$event.stopPropagation();tableMenuTrigger.openMenu();'
                                        [matMenuTriggerFor]="businessMenu">more_vert</mat-icon>
                                      <mat-menu #businessMenu="matMenu">
                                        <button class="mat-btn" mat-menu-item (click)='addBusiness(element)'>
                                          <span><img src="assets/images/add-dash.svg"> Add Business</span>
                                        </button>
                                        <button class="mat-btn" mat-menu-item (click)='viewBusiness(element)'>
                                          <span><img src="assets/images/vieweye.svg"> View</span>
                                        </button>
                                        <button class="mat-btn" mat-menu-item (click)='addGroup(element)'>
                                          <span><img src="assets/images/edit.png"> Edit</span>
                                        </button>
                                        <button class="mat-btn" mat-menu-item (click)='deleteGroup(element)'>
                                          <span><img src="assets/images/dump.svg"> Delete</span>
                                        </button>
                                        <!-- <ul class="tableRowEdit">
                                          <li class="addRow" (click)="addBusiness(element)">Add Business</li>
                                          <li class="viewRow" (click)="viewBusiness(element)">View</li>
                                          <li class="editRow" (click)="addGroup(element)">Edit</li>
                                          <li class="deleterow" (click)="deleteGroup(element)">Delete</li>
                                        </ul> -->
                                      </mat-menu>
                                    </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="displayedtemplateSharingGroupColumns;sticky: true"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedtemplateSharingGroupColumns;" (click)="viewBusiness(row)"></tr>
                                </table>
                              </div>

                              <div class="col-12 text-center" *ngIf="sharingGroupList?.length == 0">
                                <span class="NoDataFound">
                                  No Data Found
                                </span>
                              </div>

                            </div>
                          </mat-card>

                          <div class="col-12 bgWhite"  *ngIf="sharingGroupList.length > 0">
                            <div class="row align-items-center ">
                              <div class="col-12">
                                <mat-paginator [pageSizeOptions]="sharingGroupfolderPage.pageSizeOptions" [length]="sharingGroupfolderPage.limit"
                                  [pageSize]="sharingGroupfolderPage.pageSize" (page)="sharingGroupPageChange($event)" [pageIndex]="sharingGroupfolderPage.index"
                                  showFirstLastButtons></mat-paginator>
                              </div>
                            </div>
                          </div>

                        </div>
                        </mat-tab>


                        <mat-tab>
                          <div class='col-12 my-4'>
                            <mat-card class="p-0">
                              <div class="mat-elevation-z8 checkBoxlign ">
                                <div class="table-responsive striped">
                                  <table class="col-12 fixed_layout users_mod" mat-table [dataSource]="sharingGroupDetails">
                                    <ng-container matColumnDef="Name of Business">
                                      <th mat-header-cell *matHeaderCellDef>Name of Business</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{element?.bp_business.name}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Created By">
                                      <th mat-header-cell *matHeaderCellDef>Created By</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{ element?.um_user?.firstname +' '+ element?.um_user?.middlename +' '+ element?.um_user?.lastname }}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Created Date">
                                      <th mat-header-cell *matHeaderCellDef>Created Date</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{element?.updated | date : 'MMM dd, yyyy, hh:mm:ss a'}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Action">
                                      <th mat-header-cell *matHeaderCellDef> Action </th>
                                      <td mat-cell *matCellDef="let element" class="action-link">
                                        <div class="actionCol action_array">
                                          <button mat-button class="delete" (click)="deleteBusiness(element)"> </button>
                                        </div>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedtemplateSharingGroupDetailsColumns;sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedtemplateSharingGroupDetailsColumns;"></tr>
                                  </table>
                                </div>
                                <div class="col-12 text-center" *ngIf="sharingGroupDetails?.length == 0">
                                  <span class="NoDataFound">
                                    No Data Found
                                  </span>
                                </div>

                              </div>
                            </mat-card>
                          </div>
                          </mat-tab>
                        </mat-tab-group>
                      </div>




                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
    <mat-tab label="Add Business" *ngIf="membershipActive">
      <div class="col-12">
        <mat-card class="p-0 my-3">
          <div class="row m-0" *ngIf="RegBlock">
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <div class="registerBtnWrp pointer mx-auto" (click)="createBusiness(1)">
                <div class="regimg"><img src="assets/images/clipboard.svg"></div>
                <div class="regTitle">
                  <p>Register <br> Cannabis Business</p>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
              <div class="registerBtnWrp pointer mx-auto" (click)="createBusiness(2)">
                <div class="regimg"><img src="assets/images/clipboard.svg"></div>
                <div class="regTitle">
                  <p>Register <br> Non - Cannabis Business</p>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngIf="businessList.length != 0">
              <div class="registerBtnWrp pointer mx-auto ">
                <div class="regCtrl">
                  <mat-form-field class="col-12">
                    <mat-select placeholder="Business" [(ngModel)]="clnBusinss">
                      <mat-option [value]='item.bp_business_id' *ngFor="let item of selectableBusiness">
                        <div *ngIf="item.bp_business_nickname">
                          {{item.bp_business_nickname}}
                        </div>
                        <div *ngIf="!item.bp_business_nickname">
                          {{item.bp_business_name}}
                        </div>
                      </mat-option>
                    </mat-select>
                    <mat-error>Select Business
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="regCtrl">
                  <div>
                    <div class=my-2><button mat-raised-button color="primaryCus" (click)="cloneBusiness(clnBusinss,1)"
                        class="frwd_button control_buttons col-12 p-0 text-center">Clone Cannabis Business</button>
                    </div>
                    <div class=my-2><button mat-raised-button color="primaryCus" (click)="cloneBusiness(clnBusinss,2)"
                        class="frwd_button control_buttons col-12 p-0 text-center">Clone Non-Cannabis Business</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0" *ngIf="!RegBlock">
            <div class="col-sm-12 com-md-10 col-lg-10 col-xl-10 usertab">

              <div class="col-12" *ngIf="tabvis==0">
                <form [formGroup]='BusinessDetailsBasic'>
                  <div class="row ">

                    <div class="col-12 my-3 p-0 wiz_title">
                      <span class="Badge">{{titleNo.BasicDetails?.slNo}}</span>
                      <span>
                        Basic Details
                      </span>
                    </div>
                    <div class="col-12">
                      <p class="tabInnerTitle">
                        <span>Business Basic Details</span>
                      </p>
                    </div>
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Legal Business Name" formControlName="name" required (change)="isValidBusiness({name:BusinessDetailsBasic.get('name').value},
                        {formGroup:BusinessDetailsBasic,formControl:'name'})">
                        <mat-error *ngIf="BusinessDetailsBasic.get('name').errors?.required">Enter Legal Business Name
                        </mat-error>
                        <mat-error *ngIf="BusinessDetailsBasic.get('name').errors?.exist">
                          {{BusinessDetailsBasic.get('name').errors.exist}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Doing Business As" formControlName="dba">
                        <mat-error *ngIf="BusinessDetailsBasic.get('dba').errors?.required">Enter DBA</mat-error>
                      </mat-form-field>
                    </div>
<!-- 
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-sm-12">
                        <mat-select placeholder="Entity Type" formControlName="bp_entity_type"
                          (selectionChange)="changeEntityType($event,BusinessDetailsBasic,'other_entity')" required>
                          <mat-option [value]='item.bp_entity_type_id' *ngFor="let item of businessEntityList">
                            {{item.name}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="BusinessDetailsBasic.get('bp_entity_type').errors?.required">Select Entity
                          type
                        </mat-error>
                      </mat-form-field>
                    </div> -->
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <mat-select placeholder="State of Incorporation" formControlName="incorp_state">
                          <mat-option *ngFor="let item of stateList" [value]="item.bt_region_id">{{item.name}}
                          </mat-option>
                        </mat-select>
                        <!-- <mat-error *ngIf="BusinessDetailsBasic.get('incorp_state').errors?.required">Select State of
                          Incorporation
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput mask="00-0000000" [showMaskTyped]="true" placeholder="Federal Tax ID/EIN"
                        [formControl]="BusinessDetailsBasic.controls['fed_taxid']">
                        <!-- <mat-error>Enter valid Federal Tax
                          ID/EIN
                        </mat-error> -->
                      </mat-form-field>
                    </div>
                    <div *ngIf='other_entity==1' class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Entity Type" formControlName="bp_entity_type_other" required>
                        <mat-error *ngIf="BusinessDetailsBasic.get('bp_entity_type_other').errors?.required">Enter Other
                          Entity
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Nickname" formControlName="nickname" (change)="isValidBusiness({nickname:BusinessDetailsBasic.get('nickname').value},
                        {formGroup:BusinessDetailsBasic,formControl:'nickname'})" required>
                        <mat-error *ngIf="BusinessDetailsBasic.get('nickname').errors?.required">
                          Enter Nickname
                        </mat-error>
                        <mat-error *ngIf="BusinessDetailsBasic.get('nickname').errors?.exist">
                          {{BusinessDetailsBasic.get('nickname').errors.exist}}
                        </mat-error>
                      </mat-form-field>
                    </div> -->
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 custom_Errors">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Parent Company" formControlName="parent_bp_business_id"
                          [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayParent">
                          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{option.bp_business_name}}
                          </mat-option>
                        </mat-autocomplete>
                        <span class="errorMessage warningMessage"
                          *ngIf='BusinessDetailsBasic.get("parent_bp_business_id").value===""'>
                          Current business will be set as the parent
                        </span>
                        <mat-error *ngIf="BusinessDetailsBasic.get('parent_bp_business_id').errors?.required">
                          Select Parent Company
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Business Type(s)" formControlName="business_type">
                      </mat-form-field>
                    </div>

                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 mt-2" *ngIf="RegType == 1">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Type" [(ngModel)]="tntType" required>
                                <mat-option *ngFor="let item of tntList" [value]="item.bp_tnt_type_id">
                                  {{item?.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf="RegType == 1">
                            <mat-form-field class="col-12">
                              <mat-select placeholder="Metrc State" formControlName="metrc_state">
                                <mat-option *ngFor="let item of Cannabistates" [value]="item.bt_region_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="showValidationMessage && BusinessDetailsBasic.controls['metrc_state'].hasError('required')">
                                Metrc State selection is required because the input field has a value.
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-8 col-lg-8 col-xl-8" *ngIf="RegType == 1">  
                            <mat-form-field class="col-12">
                            <input matInput placeholder="Metrc Key" formControlName="metrc_key" (input)="checkValidation()">
                            <img   matTooltipClass="matToolTipCmmnt" class="txttooltip"
                            matTooltip="{{tooltip}}" src="/assets/images/i.svg">
                          </mat-form-field>
                            <!-- <textarea appInputLimit [(ngModel)]="metrcKey" class="chatInputArea w-100" rows="1" placeholder=""></textarea>
                            <img   matTooltipClass="matToolTipCmmnt" class="txttooltip"
                            [title]="tooltip" src="/assets/images/i.svg"> &nbsp;&nbsp; -->
                          </div>
                    
                  </div>
                </form>
              </div>
              <!-- <div class="col-12" *ngIf="tabvis==1 && RegType == 1">
                <form [formGroup]='CannabisDetails'>
                  <div class="row">
                    <div class="col-12 my-3 p-0 wiz_title">
                      <span class="Badge">{{titleNo.CannabisRelatedDetails?.slNo}}</span>
                      <span>
                        Cannabis Related Details
                      </span>
                    </div>
                    <div class="row ">
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-sm-12">
                          <mat-select placeholder="Cannabis Business Type" formControlName="CanabusBusnessType"
                            (selectionChange)="changeCannBussType($event, CannabisDetails, 'Canabis_bus_other_type' , 'Lab')"
                            required>
                            <mat-option *ngFor="let item of businessLicenseList" [value]='item'>
                              {{item.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="CannabisDetails.get('CanabusBusnessType').errors?.required">Select Cannabis
                            Business Type</mat-error>
                        </mat-form-field>

                      </div>
                      <div *ngIf='Canabis_bus_other_type==1' class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Cannabis Business Type" formControlName="CanabusBusnessTypeOther"
                            required>
                          <mat-error *ngIf="CannabisDetails.get('CanabusBusnessTypeOther').errors?.required">Enter
                            Cannabis
                            Business Type</mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <mat-select placeholder="Cannabis Licensed Country" formControlName="CountryList" (selectionChange)="getCannabisStates($event.value)">
                            <mat-option *ngFor="let item of Cannabiscountry" [value]="item.bt_country_id">
                              {{item.name}}
                            </mat-option>
                          </mat-select> 
                          <mat-error *ngIf="CannabisDetails.get('CountryList').errors">Select Country
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <mat-select placeholder="Cannabis Licensed State/Province " formControlName="CannabisLicensedState"
                            required>
                            <mat-option *ngFor="let item of Cannabistates" [value]="item.bt_region_id">{{item.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="CannabisDetails.get('CannabisLicensedState').errors?.required">Cannabis
                            Licensed
                            State </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Cannabis Business License Number"
                            formControlName="CannabisLicenceNumber" required
                            (change)="isValidBusiness({license:CannabisDetails.get('CannabisLicenceNumber').value},
                              {formGroup:CannabisDetails,formControl:'CannabisLicenceNumber'})">
                          <mat-error *ngIf="CannabisDetails.get('CannabisLicenceNumber').errors?.required ||
                          CannabisDetails.get('CannabisLicenceNumber').errors?.invalidLicense
                          ">Enter a valid
                            Cannabis
                            Business License Number</mat-error>
                            <mat-error *ngIf="CannabisDetails.get('CannabisLicenceNumber').errors?.exist">
                              {{CannabisDetails.get('CannabisLicenceNumber').errors.exist}}
                            </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput [matDatepicker]="picker" [min]='minDate' placeholder="Expiration Date"
                            formControlName="ExpirationDate">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Cannabis Tax ID" formControlName="CannabisTaxID">
                          <mat-error>Enter valid Cannabis Tax ID (only alphabhets , numbers , hyphen and slashes are
                            allowed)
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-sm-12">
                          <mat-select placeholder="Cannabis License Category" formControlName="CanabisCategory"
                            (selectionChange)='IsOtherCategory($event, CannabisDetails, "OtherCanbisCategoy")' required>
                            <mat-option *ngFor="let item of CanabisCategorylist" (click)="CanabisCategory=item.name;"
                              [value]='item.bp_license_type_desig_id'>
                              {{item.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="CannabisDetails.get('CanabisCategory').errors?.required">Select Cannabis
                            License Category</mat-error>
                        </mat-form-field>

                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='OtherCanbisCategoy == 1'>
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Cannabis License Category"
                            formControlName="bp_license_type_desig_comment" required>
                          <mat-error *ngIf="CannabisDetails.get('bp_license_type_desig_comment').errors?.required">Enter
                            Cannabis License Category
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-8 acrediation com-md-8 col-lg-8 col-xl-12" *ngIf='Lab==true'>
                        <mat-checkbox class="col-12" formControlName='is_accredited'
                          (change)='IsAcreditedLab(CannabisDetails.get("is_accredited").value , CannabisDetails)'>Is
                          this business an
                          accredited cannabis business?
                        </mat-checkbox>
                      </div>
                    </div>
                    <div class='row accrediations' *ngIf='CannabisDetails.get("is_accredited").value==true'>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-sm-12">
                          <mat-select placeholder="Accreditation Standard" formControlName="accreditation_standard"
                            (selectionChange)="changeStandard($event , CannabisDetails)" required>
                            <mat-option *ngFor="let item of accreditionstanList"
                              [value]='item.bp_accredition_standard_type_id'>
                              {{item.name}}
                            </mat-option>

                          </mat-select>
                          <mat-error *ngIf="CannabisDetails.get('accreditation_standard').errors?.required">Enter
                            Accreditation Standard
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4"
                        *ngIf='CannabisDetails.get("isOtherStandard").value'>
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Accreditation Standard"
                            formControlName="accredition_standard_comment" required>
                          <mat-error *ngIf="CannabisDetails.get('accredition_standard_comment').errors?.required">Enter
                            Accreditation Standard
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput [matDatepicker]="picker2" [min]='minDate'
                            placeholder="Accreditation Expiration" formControlName="accreditation_expiration" required>
                          <mat-error >Select
                           valid Accreditation Expiration Date
                          </mat-error>
                          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                          <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Certificate Number" formControlName="certificate_number"
                            required>
                          <mat-error *ngIf="CannabisDetails.get('certificate_number').errors?.required">Enter
                            Certificate Number
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Accreditation Number" formControlName="accreditation_no"
                            required>
                          <mat-error *ngIf="CannabisDetails.get('accreditation_no').errors?.required">Enter
                            Accreditation
                            Number
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Accredited Facility ID"
                            formControlName="accreditation_test_lab_id" required>
                          <mat-error *ngIf="CannabisDetails.get('accreditation_test_lab_id').errors?.required">Enter
                            Facility ID
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-6 col-lg-6 col-xl-6">
                        <mat-form-field class="col-12">
                          <input type="text" readonly matInput placeholder="Upload Certificate"
                            formControlName="certificate_image">
                          <mat-error *ngIf="CannabisDetails.controls.certificate_image.errors?.required">Upload
                            Certificate
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3 d-flex align-items-center">
                        <button class="choosebutton">
                          <input type="file" (change)='passCertificate($event , "Add")' #attachInput>
                          Choose Certificate
                        </button>
                        <div class="tooltipImg ml-1">
                          <img src="assets/images/i.svg" alt="" [title]="instructionString">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div> -->
              <!-- <div class="col-12 mt-4" *ngIf="tabvis==2">
`
                <div class="row">
                  <div class="col-12 my-3 p-0 wiz_title">
                    <span class="Badge">{{titleNo.ContactDetails?.slNo}}</span>
                    <span>
                      Business Bank Account Details 
                    </span>
                  </div>
                  <div class="col-12 bankqn">
                    <mat-checkbox class="col-12" [(ngModel)]='need_fin_inst_acc_assis_edit' (change)='updateNeedBankAssistance($event)'>I would like
                      assistance in
                      opening a cannabis
                      supported business banking account
                    </mat-checkbox>
                  </div>
    
                  <div class="col-12 banklist">
                    <div class="row">
                      <div class="col-12 p-0">
                        <form [formGroup]="BankDetails" #BankEdit="ngForm">
                            <div class="row ">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput type="text" (keypress)="keyPressNumbers($event)" [maxlength]="9" placeholder="Routing Number"  maxlength="9" formControlName="business_bank_routing_number">
                              <mat-error *ngIf="BankDetails.get('business_bank_routing_number').errors?.required">
                                Enter a valid Routing Number</mat-error>
                              <mat-error *ngIf="BankDetails.get('business_bank_routing_number').errors?.MaxLength ">
                                Maximum length of Routing Number should be
                                {{
                                BankDetails.get('business_bank_routing_number').errors.MaxLength.requiredLength
                                }}
                              </mat-error>
                              <mat-error *ngIf="BankDetails.get('business_bank_routing_number').errors?.MinLength">
                                Minimum length of Routing Number should be
                                {{
                                BankDetails.get('business_bank_routing_number').errors.MinLength.requiredLength
                                }}
                              </mat-error>
                            </mat-form-field>
    
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput type="text"  (keypress)="keyPressNumbers($event)" [maxlength]="9"  [errorStateMatcher]="errorMatcherRouting"   maxlength="10" (paste)="$event.preventDefault();" placeholder="Re-enter Routing Number" formControlName="ConfirmBankRoutingNo">
                              <mat-error *ngIf="BankDetails.hasError('routingNoDoNotMatch')"> Routing Numbers
                                should be
                                same
                              </mat-error>
                                <mat-error *ngIf="BankDetails.get('ConfirmBankRoutingNo').hasError('required')">
                                    Enter a valid Routing Number</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput type="text"  (keypress)="keyPressNumbers($event)" [maxlength]="20"  placeholder="Bank Account Number"  maxlength="20" formControlName="business_bank_account_number">
                              <mat-error *ngIf="BankDetails.get('business_bank_account_number').errors?.required">
                                Enter a valid Bank Account Number</mat-error>
                              <mat-error *ngIf="BankDetails.get('business_bank_account_number').errors?.MaxLength ">
                                Maximum length of Bank Account Number should be
                                {{
                                BankDetails.get('business_bank_account_number').errors.MaxLength.requiredLength
                                }}
                              </mat-error>
                              <mat-error *ngIf="BankDetails.get('business_bank_account_number').errors?.MinLength">
                                Minimum length of Bank Account Number should be
                                {{
                                BankDetails.get('business_bank_account_number').errors.MinLength.requiredLength
                                }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput type="text"  (keypress)="keyPressNumbers($event)" [maxlength]="20"  [errorStateMatcher]="errorMatcherAc"  maxlength="20" placeholder="Re-enter Bank Account Number" formControlName="ConfirmBankAcNo">
                              <mat-error *ngIf="BankDetails.hasError('AcnoDoNotMatch')">Bank Account Numbers
                                should be
                                same
                              </mat-error>
                              <mat-error *ngIf="BankDetails.get('ConfirmBankAcNo').errors?.required">
                                Enter a valid Bank Account Number</mat-error>
                            </mat-form-field>
                          </div>
    
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <button class="rounded_yellow_button" mat-flat-button color="primary" *ngIf="editClicked === false" [disabled]="!BankDetails.valid" (click)="addBankDetails(BankDetails,'BankDetailsList_edit')">Add</button>
                            <div *ngIf="editClicked === true">
                              <button class="rounded_yellow_button" mat-flat-button color="primary" [disabled]="!BankDetails.valid" (click)="editBankDetails(BankDetails,'BankDetailsList_edit')">Update</button>
                              <button mat-button class="fclear mr-1" (click)="clear()">Cancel
                              </button>
                            </div>
                          </div>
                            </div>
                        </form>
                      </div>
                    </div>
                  </div>
    
                </div>
              </div> -->
              <div class="col-12" *ngIf="tabvis==1">
                <form [formGroup]='ContactDetails'>
                  <div class="row ">
                    <div class="col-12 my-3 p-0 wiz_title">
                      <!-- <span class="Badge">{{titleNo.ContactDetails?.slNo}}</span> -->
                      <span class="Badge">2</span>
                      <span>
                        Contact Details
                      </span>
                    </div>
                    <div class="col-12">
                      <p class="tabInnerTitle">
                        <span>Legal/Registered Address</span>
                      </p>
                    </div>
                    <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                      <mat-form-field class="col-12">
                        <mat-select placeholder="Country" formControlName="CountryList"
                          (selectionChange)="findZipBusinessDetails(ContactDetails)">
                          <mat-option *ngFor="let item of country" [value]="item.bt_country_id">
                            {{item.name}}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="ContactDetails.get('CountryList').errors?.required">Select Country</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Zip Code" formControlName="ZipCode" required>
                        <mat-error *ngIf="ContactDetails.get('ZipCode').errors">Enter a valid Zip Code
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="State" formControlName="State">
                        <mat-error *ngIf="ContactDetails.get('State').errors?.required">Enter State</mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="County" formControlName="County">
                        <mat-error *ngIf="ContactDetails.get('County').errors?.required">Enter County</mat-error>
                      </mat-form-field>
                    </div> -->
                    <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="City" formControlName="City">
                        <mat-error *ngIf="ContactDetails.get('City').errors?.required">Enter City</mat-error>
                      </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Street Number" formControlName="StreetNumber" required>
                        <mat-error *ngIf="(ContactDetails.get('StreetNumber').errors?.required ||
                        ContactDetails.get('StreetNumber').errors?.isFullSpace ||
                        ContactDetails.get('StreetNumber').errors?.invalidStreetNum
                        ) &&
                        !ContactDetails.get('StreetNumber').errors?.maxlength
                        ">
                          Enter a valid Street Number
                        </mat-error>
                        <mat-error *ngIf="ContactDetails.get('StreetNumber').errors?.maxlength">
                          Maximum length of street number should be
                          {{ContactDetails.get('StreetNumber').errors.maxlength.requiredLength}}
                        </mat-error>
                      </mat-form-field>
                    </div> -->
                    <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Street Address" formControlName="StreetName" (input)="onInputChange($event.target.value, ContactDetails)" required>
                        <mat-error *ngIf="ContactDetails.get('StreetName').errors?.required">Enter Street Address
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                      <mat-form-field class="col-12">
                        <input matInput placeholder="Unit" formControlName="Unit">
                        <mat-error>
                          Maximum length of Unit should be
                          {{ContactDetails.get('Unit').errors?.maxlength.requiredLength}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12 p-0">
                      <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5">
                        <mat-form-field class="col-12">
                          <input matInput placeholder="Business URL" formControlName="BusinessURL">
                          <mat-error>Enter a valid Business Website
                            URL
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-12">
                      <mat-checkbox formControlName="is_correct_zip_legal"
                        (change)='BusinessDetailsIncorrectZip($event,ContactDetails)' class="col-12">Edit state
                        county , city
                        details ?
                      </mat-checkbox>
                    </div>
                    <div class="col-12" formArrayName="items"
                      *ngFor="let item of ContactDetails.get('items').controls; let i = index;">
                      <div class="row phonearray" [formGroupName]="i">
                        <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">

                          <mat-form-field class="col-12">
                            <input type='text' matInput placeholder="Business Phone Number" 
                            [formControl]="ContactDetails.get('items').controls[i].get('phone')"
                              mask="(000) 000-0000" [showMaskTyped]="true">
                            <mat-error>
                              Enter a
                              Valild Business Phone No.</mat-error>
                          </mat-form-field>

                        </div>
                        <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                          <div class="">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Business Phone Type" formControlName="phone_type_id">
                                <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                  {{item.name}}
                                </mat-option>

                              </mat-select>
                              <mat-error
                                *ngIf="ContactDetails.get('items').controls[i].get('phone_type_id').errors?.required">
                                Select
                                Phone Type</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="col-sm-2  BusAddCnctBtn ">
                          <button class="addBtn newtrash" (click)="CloseItem(item,ContactDetails,'items')"
                            *ngIf="ContactDetails.get('items').controls.length > 1">
                            <img src="assets/images/trash.svg">
                          </button>

                          <button class="addBtn" *ngIf="i == (ContactDetails.get('items').controls.length)-1" style="padding: 2px 5px !important;"
                            [disabled]="ContactDetails.get('items')['controls'][i]['value']['phone']?.length!=10 || !ContactDetails.get('items')['controls'][i]['value']['phone_type_id']"

                            (click)="addItem(ContactDetails,'items')">
                            <img src="assets/images/add.svg">
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <p class="tabInnerTitle">
                        <span>Primary Business Location</span>
                      </p>
                    </div>
                    <div class="col-sm-12 p-0">
                      <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5">
                        <mat-checkbox formControlName="is_legal_premise_addr_same" 
                          (change)='DisableBusines_Validation(ContactDetails)' class="col-12">Same as Legal Address
                        </mat-checkbox>
                      </div>
                    </div>


                    <div class="col-12" *ngIf="!ContactDetails.get('is_legal_premise_addr_same').value">
                      <div class="row">
                        <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                          <mat-form-field class="col-12">
                            <mat-select placeholder="Country" formControlName="PreCountryList"
                              (selectionChange)="findZipBusinessDetailsPrem(ContactDetails)" required>
                              <mat-option *ngFor="let item of country" [value]="item.bt_country_id">
                                {{item.name}}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="ContactDetails.get('PreCountryList').errors?.required">Select Country
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="Zip Code" formControlName="PreZipCode" required>
                            <mat-error *ngIf="ContactDetails.get('PreZipCode').errors">Enter a valid Zip Code
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="State" formControlName="PreState">
                            <mat-error *ngIf="ContactDetails.get('PreState').errors?.required">Enter State
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="County" formControlName="PreCounty">
                            <mat-error *ngIf="ContactDetails.get('PreCounty').errors?.required">Enter your county
                            </mat-error>
                          </mat-form-field>
                        </div> -->
                        <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="City" formControlName="PreCity">
                            <mat-error *ngIf="ContactDetails.get('PreCity').errors?.required">Enter City
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="Street Number" formControlName="PreStreetNumber" required>
                            <mat-error *ngIf="(ContactDetails.get('PreStreetNumber').errors?.required ||
                            ContactDetails.get('PreStreetNumber').errors?.invalidStreetNum  ||
                            ContactDetails.get('PreStreetNumber').errors?.isFullSpace) &&
                            !ContactDetails.get('PreStreetNumber').errors?.maxlength
                            ">
                              Enter a valid Street Number
                            </mat-error>
                            <mat-error *ngIf="ContactDetails.get('PreStreetNumber').errors?.maxlength">
                              Maximum length of street number should be
                              {{ContactDetails.get('PreStreetNumber').errors.maxlength.requiredLength}}
                            </mat-error>
                          </mat-form-field>
                        </div> -->
                        <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="Street Address" formControlName="PreStreetName" required>
                            <mat-error *ngIf="ContactDetails.get('PreStreetName').errors?.required">Enter Street Address
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2">
                          <mat-form-field class="col-12">
                            <input matInput placeholder="Unit" formControlName="PreUnit">
                            <mat-error>
                              Maximum length of Unit should be
                              {{ContactDetails.get('PreUnit').errors?.maxlength.requiredLength}}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col-12">
                          <mat-checkbox formControlName="is_correct_zip_pre"
                            (change)='BusinessDetailsPreIncorrectZip($event,ContactDetails)' class="col-12">Edit
                            state, county ,
                            city
                            details ?
                          </mat-checkbox>
                        </div >
                        <div *ngIf='ContactDetails' class="wd_80">
                          <div class="wd_80 col-12" formArrayName="Preitems"
                          *ngFor="let item of ContactDetails.get('Preitems').controls; let i = index;">
                          <div class="row" [formGroupName]="i">
                            <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">

                              <mat-form-field class="col-12">
                                <input type='text' matInput placeholder="Business Phone Number" 
                                [formControl]="ContactDetails.get('Preitems').controls[i].get('phone')"
                                  mask="(000) 000-0000" [showMaskTyped]="true">
                                <mat-error
                                  >
                                  Enter a valid Business Phone No.</mat-error>
                              </mat-form-field>

                            </div>
                            <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3">
                              <mat-form-field class="col-12">
                                <mat-select placeholder="Business Phone Type" formControlName="phone_type_id">
                                  <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                    {{item.name}}
                                  </mat-option>
                                </mat-select>
                                <mat-error
                                  *ngIf="ContactDetails.get('Preitems').controls[i].get('phone_type_id').errors?.required">
                                  Select Phone Type</mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-sm-2">
                              <div class="BusAddCnctBtn closep"
                                *ngIf="ContactDetails.get('Preitems').controls.length > 1">
                                <button class="addBtn newtrash" (click)="CloseItem(item,ContactDetails,'Preitems')">
                                  <img src="assets/images/trash.svg">
                                </button>
                              </div>
                              <div class="BusAddCnctBtn"
                                *ngIf="i == (ContactDetails.get('Preitems').controls.length)-1">
                                <button class="addBtn" style="padding: 2px 5px !important;"
                                 [disabled]="ContactDetails.get('Preitems')['controls'][i]['value']['phone']?.length!=10 || !ContactDetails.get('Preitems')['controls'][i]['value']['phone_type_id']"

                                  (click)="addItem(ContactDetails,'Preitems')">
                                  <img src="assets/images/add.svg">
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-12 " *ngIf="tabvis==2">
                <div class="row ">
                  <div class="col-12 my-3 p-0 wiz_title">
                    <!-- <span class="Badge">{{titleNo.KeyPersonRegistration?.slNo}}</span> -->
                    <span class="Badge">3</span>
                    <span>
                      Key Person Registration
                    </span>
                  </div>
                  <div class="userselection_tabs col-sm-12">
                    <p>Select the type of user to add</p>

                    <div class="col-12 p-0 highres_options">
                      <div class="row">
                        <div class="col-4">
                          <div [ngClass]='{"switch_color":tab==1}' class="selector" (click)='tab=1'>
                            <img *ngIf="tab!==1" src="assets/images/squareadd.png"><img *ngIf="tab==1"
                              src="assets/images/squaretick.png">
                            <p> BENEFICIAL OWNER (B)</p>
                          </div>
                        </div>
                        <div class="col-5">
                          <div [ngClass]='{"switch_color":tab==2}' class="selector" (click)='tab=2'><img
                              *ngIf="tab!==2" src="assets/images/squareadd.png"><img *ngIf="tab==2"
                              src="assets/images/squaretick.png">
                            <p>CONTROLLING MANAGERS/OPERATORS (C)</p>
                          </div>
                        </div>
                        <div class="col-3">
                          <div [ngClass]='{"switch_color":tab==3}' class="selector" (click)='tab=3'><img
                              *ngIf="tab!==3" src="assets/images/squareadd.png"><img *ngIf="tab==3"
                              src="assets/images/squaretick.png">
                            <p>INVESTOR (I)</p>
                          </div>
                        </div>
                        <!-- <div class="col-3">
                          <div [ngClass]='{"switch_color":tab==4}' class="selector" (click)='SetTab(4)'><img
                              *ngIf="userselect==0&&tab!==4" src="assets/images/squareadd.png"><img
                              *ngIf="tab==4" src="assets/images/squaretick.png">
                            <p>CONTACT PERSON</p>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-12" *ngIf='tab==1'>
                      <form [formGroup]="BeneOwner">
                        <div class="row userform">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="First Name" formControlName="firstname" required>
                              <mat-error *ngIf="BeneOwner.get('firstname').errors?.required">Enter First Name
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Middle Name" formControlName="middlename">
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Last Name" formControlName="lastname" required>
                              <mat-error *ngIf="BeneOwner.get('lastname').errors?.required">Enter Last Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input type="email" matInput placeholder="Email" formControlName="email" required>
                              <!-- <mat-error *ngIf="BeneOwner.get('email').errors?.required">Enter Email </mat-error> -->
                              <mat-error *ngIf="BeneOwner.get('email').errors">Enter a valid Email</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput type='number' placeholder="Percentage Ownership"
                                formControlName="ownership_percent" min="0" max="100" required>
                              <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px" height="14px"
                                matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                              <mat-error>Enter a valid percentage Ownership (>=20%)</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Access Type" formControlName="role_id" required>
                                <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="BeneOwner.get('role_id').errors?.required">Select Access Type
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class='col-12 d-flex'>
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                              Does this User has any other roles?
                            </div>
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">

                              <mat-checkbox
                                (change)='UserControl.BeneOwnerControl=$event.checked;IsValidate($event,BeneOwner,"bp_user_title_id")'
                                [value]='UserControl.BeneOwnerControl' [checked]='UserControl.BeneOwnerControl==true'>
                                Controlling Managers/Operators
                              </mat-checkbox>
                            </div>
                            <div class="col-sm-12 com-md-2 col-lg-4 col-xl-2 extraflds">
                              <mat-checkbox
                                (change)='UserControl.BeneOwnerInvestor=$event.checked;IsValidate($event,BeneOwner,"bp_investor_type_id")'
                                [value]='UserControl.BeneOwnerInvestor' [checked]='UserControl.BeneOwnerInvestor==true'>
                                Investor
                              </mat-checkbox>
                            </div>

                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.BeneOwnerControl==true'>
                            <mat-form-field class="col-sm-12">
                              <input matInput type='text' placeholder="Title"
                              formControlName="bp_user_title_id">
                              <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" >
                                <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select> -->
                              <!-- <mat-error *ngIf="BeneOwner.get('bp_user_title_id').errors?.required">Select Title
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.BeneOwnerInvestor==true'>
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                (selectionChange)="changeInvesterType($event,'BenOwner')" required>
                                <mat-option *ngFor="let item of investorTypeList" [value]="item.bp_investor_type_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="BeneOwner.get('bp_investor_type_id').errors?.required">Select Investor
                                Type
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group1==1'>
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Investing Group Name"
                                formControlName="bp_investor_type_comment" required>
                              <mat-error *ngIf="investor.get('bp_investor_type_comment').errors?.required">Enter
                                Investing
                                Group Name</mat-error>
                            </mat-form-field>
                          </div>

                          <div class="col-12 user_edits">
                            <div class="checkbox">
                              <mat-checkbox formControlName="is_contact_person">Set as Contact Person</mat-checkbox>
                            </div>
                            <div>
                              <button type="button" (click)='resetRegForm("group1","tab",BeneOwner , "UserControl" ,"beneOwner")'
                                class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                color="primary">Cancel</button>
                              <button type="button" [disabled]="!BeneOwner.valid"
                                (click)='addUsers(BeneOwner,"UserControl", "UserList" , "add")' class="rounded_yellow_button"
                                mat-flat-button color="primary">Add</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-12" *ngIf='tab==2'>
                      <form [formGroup]="operators">
                        <div class="row userform">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="First Name" formControlName="firstname" required>
                              <mat-error *ngIf="operators.get('firstname').errors?.required">Enter First Name
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Middle Name" formControlName="middlename">
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Last Name" formControlName="lastname" required>
                              <mat-error *ngIf="operators.get('lastname').errors?.required">Enter Last Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input type="email" matInput placeholder="Email" formControlName="email" required>
                              <mat-error *ngIf="operators.get('email').errors">Enter a valid Email</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <input matInput placeholder="Title"
                                formControlName="bp_user_title_id">
                              <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" >
                                <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select> -->
                              <!-- <mat-error *ngIf="operators.get('bp_user_title_id').errors?.required">Select Title
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Access Type" formControlName="role_id" required>
                                <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="operators.get('role_id').errors?.required">Select Access Type</mat-error>
                            </mat-form-field>
                          </div>
                          <div class='col-12 d-flex'>
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                              Does this User has any other roles?
                            </div>
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                              <mat-checkbox
                                (change)='UserControl.ControlBeneOwner=$event.checked;IsValidate($event,operators,"ownership_percent")'
                                [value]='UserControl.ControlBeneOwner' [checked]='UserControl.ControlBeneOwner==true'>
                                Beneficial Owner
                              </mat-checkbox>
                            </div>
                            <div class="col-sm-12 com-md-2 col-lg-4 col-xl-2 extraflds">
                              <mat-checkbox
                                (change)='UserControl.ControlInvestor=$event.checked;IsValidate($event,operators,"bp_investor_type_id")'
                                [value]='UserControl.ControlInvestor' [checked]='UserControl.ControlInvestor==true'>
                                Investor
                              </mat-checkbox>
                            </div>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.ControlBeneOwner==true'>
                            <mat-form-field class="col-12">
                              <input matInput type='number' placeholder="Percentage Ownership"
                                formControlName="ownership_percent" min="0" max="100" required>
                              <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px" height="14px"
                                matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                              <mat-error>Enter a valid percentage Ownership (>=20%)</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.ControlInvestor==true'>
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                (selectionChange)="changeInvesterType($event,'Operator')" required>
                                <mat-option *ngFor="let item of investorTypeList" [value]="item.bp_investor_type_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="operators.get('bp_investor_type_id').errors?.required">Select Investor
                                Type
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group2==1'>
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Investing Group Name"
                                formControlName="bp_investor_type_comment" required>
                              <mat-error *ngIf="operators.get('bp_investor_type_comment').errors?.required">Enter
                                Investing
                                Group Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-12 user_edits">
                            <div class="checkbox">
                              <mat-checkbox formControlName="is_contact_person">Set as Contact Person</mat-checkbox>
                            </div>
                            <div>
                              <button type="button" (click)='resetRegForm( "group2" ,"tab",operators , "UserControl" ,"operator")'
                                class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                color="primary">Cancel</button>
                              <button type="button" (click)='addUsers(operators,"UserControl", "UserList" , "add")'
                                [disabled]="!operators.valid" class="rounded_yellow_button" mat-flat-button
                                color="primary">Add</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-12" *ngIf='tab==3'>
                      <form [formGroup]="investor">
                        <div class="row userform">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="First Name" formControlName="firstname" required>
                              <mat-error *ngIf="investor.get('firstname').errors?.required">Enter First Name</mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Middle Name" formControlName="middlename">
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Last Name" formControlName="lastname" required>
                              <mat-error *ngIf="investor.get('lastname').errors?.required">Enter Last Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Email" formControlName="email" required>
                              <mat-error *ngIf="investor.get('email').errors">Enter a valid Email</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Investor Type" formControlName="bp_investor_type_id"
                                (selectionChange)="changeInvesterType($event,'Investor')" required>
                                <mat-option *ngFor="let item of investorTypeList" [value]="item.bp_investor_type_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="investor.get('bp_investor_type_id').errors?.required">Select Investor
                                Type
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='group==1'>
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Investing Group Name"
                                formControlName="bp_investor_type_comment" required>
                              <mat-error *ngIf="investor.get('bp_investor_type_comment').errors?.required">Enter
                                Investing
                                Group Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Access Type" formControlName="role_id" required>
                                <mat-option *ngFor="let item of accessTypeList" [value]="item.um_role_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="investor.get('role_id').errors?.required">Select Access Type</mat-error>
                            </mat-form-field>
                          </div>
                          <div class='col-12 d-flex'>
                            <div class="col-sm-12 com-md-5 col-lg-5 col-xl-5 extraflds">
                              Does this User has any other roles?
                            </div>
                            <div class="col-sm-12 com-md-3 col-lg-3 col-xl-3 extraflds">
                              <mat-checkbox
                                (change)='UserControl.InvestBeneOwner=$event.checked;IsValidate($event,investor,"ownership_percent")'
                                [value]='UserControl.InvestBeneOwner' [checked]='UserControl.InvestBeneOwner==true'>
                                Beneficial Owner
                              </mat-checkbox>
                            </div>
                            <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4 extraflds">
                              <mat-checkbox
                                (change)='UserControl.InvestorControl=$event.checked;IsValidate($event,investor,"bp_user_title_id")'
                                [value]='UserControl.InvestorControl' [checked]='UserControl.InvestorControl==true'>
                                Controlling Managers/Operators
                              </mat-checkbox>
                            </div>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.InvestBeneOwner==true'>
                            <mat-form-field class="col-12">
                              <input matInput type='number' placeholder="Percentage Ownership"
                                formControlName="ownership_percent" min="0" max="100" required>
                              <mat-error>Enter a valid percentage Ownership (>=20%)</mat-error>
                              <img matSuffix class="input-icon" src="assets/images/i.svg" width="14px" height="14px"
                                matTooltip="{{oWpercent}}" class="suffixIcon owPercent">
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4" *ngIf='UserControl.InvestorControl==true'>
                            <mat-form-field class="col-sm-12">
                              <input matInput type='text' placeholder="Title"
                              formControlName="bp_user_title_id">
                              <!-- <mat-select placeholder="Title" formControlName="bp_user_title_id" >
                                <mat-option *ngFor="let item of titleList" [value]="item.bp_user_title_id">
                                  {{item.name}}
                                </mat-option>
                              </mat-select> -->
                              <!-- <mat-error *ngIf="investor.get('bp_user_title_id').errors?.required">Select Title
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                          <div class="col-12 user_edits">
                            <div class="checkbox">
                              <mat-checkbox formControlName="is_contact_person">Set as Contact Person</mat-checkbox>
                            </div>
                            <div>
                              <button type="button" (click)='resetRegForm( "group" ,"tab",investor , "UserControl" ,"investor")'
                                class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                color="primary">Cancel</button>
                              <button type="button" [disabled]="!investor.valid"
                                (click)='addUsers(investor,"UserControl", "UserList" , "add")' class="rounded_yellow_button"
                                mat-flat-button color="primary">Add</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-12" *ngIf='tab==4'>
                      <form [formGroup]="contactPerson">
                        <div class="row userform">
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="First Name" formControlName="firstname" required>
                              <mat-error *ngIf="contactPerson.get('firstname').errors?.required">Enter Contact Person's
                                First Name</mat-error>
                            </mat-form-field>
                          </div>
                          <!-- <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Middle Name" formControlName="middlename">
                            </mat-form-field>
                          </div> -->
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input matInput placeholder="Last Name" formControlName="lastname" required>
                              <mat-error *ngIf="contactPerson.get('lastname').errors?.required">Enter Contact Person's
                                Last
                                Name</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-12">
                              <input type='text' matInput placeholder="Phone Number" mask="(000) 000-0000"
                                [showMaskTyped]="true" formControlName="phonenumber">
                              <mat-error >Enter a valid Contact
                                Person's Phone Number</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-sm-12 com-md-4 col-lg-4 col-xl-4">
                            <mat-form-field class="col-sm-12">
                              <mat-select placeholder="Phone Type" formControlName="phonetype">
                                <mat-option *ngFor="let item of phoneTypeList" [value]='item.bt_phone_type_id'>
                                  {{item.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="contactPerson.get('phonetype').errors?.required">Enter Contact Person's
                                Phone Type</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-12 user_edits">
                            <div></div>
                            <div>
                              <button type="button" (click)='tab=0' class="rounded_yellow_button cancel_button  mr-2" mat-flat-button
                                color="primary">Cancel</button>
                              <button type="button" (click)='addUsers(contactPerson,"UserControl", "UserList" , "add")'
                                [disabled]="!contactPerson.valid" class="rounded_yellow_button" mat-flat-button
                                color="primary">Add</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="userData">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <!-- <th>Is contact person</th> -->
                            <th>% of Ownership</th>
                            <th>Investor Type</th>
                            <th>Title</th>
                            <th>Access Type</th>
                            <th>User Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr *ngFor="let item of UserList; let i=index">
                            <td class="contact_person ">
                              <div class="ph-icon" *ngIf='item.is_contact_person=="Y"'><img title="Contact Person"   src="assets/images/call.png"></div>
                              {{item.firstname}} {{item.middlename}} {{item.lastname}}  
                            </td>
                            <td>{{item.email}}</td>
                            <!-- <td>{{item.is_contact_person}}</td> -->
                            <td>{{item.ownership_percent}}</td>
                            <!-- <td>{{item.bp_user_title_id |  getname:getInvesterType:'bp_user_title_id'}}</td> -->
                            <td>{{item.bp_investor_type_id | getname:investorTypeList:'bp_investor_type_id'}}</td>
                            <!-- <td>{{item.bp_user_title_id | getname:titleList:'bp_user_title_id'}}</td> -->
                            <td>{{item.bp_user_title_id}}</td>
                            <td>{{item.role_id | getname:accessTypeList:'um_role_id'}}</td>
                            <td>
                              <div class="types_circle d-flex align-items-center">
                                <span *ngFor='let usid of item.user_associations ; let i=index'>
                                  <!-- {{usid | json}} -->
                                  <span class='Investor'
                                    *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Investor"'>
                                    <div>I</div>
                                  </span>
                                  <span class='controller'
                                    *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Controlling Managers & Operators"'>C</span>
                                  <span class='Bo'
                                    *ngIf='(usid | getname:associationList:"bp_user_association_id")=="Beneficial owner"'>B</span>
                                </span>
                              </div>
                            </td>
                            <td>
                              <table class="user_edit_table">
                                <tbody>
                                  <tr class="user_edit_icons">
                                    <td class="p-0 "><img src="assets/images/pen.svg" alt=""
                                        (click)=" openDialog(item,'UserList',i)" class="mr-2"></td>
                                    <td class="p-0" *ngIf="i > 0" (click)="deleteUser(item,'UserList')"><img
                                        src="assets/images/dump.svg" class="" alt="">
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
                <div class="row align-items-center ">
                  <div class="col-12 my-3">
                    <div class="dot_ind_legend flex">

                      <div class="flex">
                        <p class="Bo mb-2 mr-2 legend-line-height">B</p>
                        <div class="legend-text">Beneficial owner</div>
                      </div>
                      <div class="flex">
                        <p class="controller mb-2 mr-2 legend-line-height">C
                        </p>
                        <div class="legend-text">Controlling Managers & Operators</div>
                      </div>
                      <div class="flex">
                        <p class="Investor mb-2 mr-2 legend-line-height">I</p>
                        <div class="legend-text"> Investor</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 com-md-2 col-lg-2 col-xl-2 tabnavbg">
              <div class="row h-100 justify-content-center">
                <div class="tabnav align-self-center">
                  <ul>
                    <li (click)='goToTab(0)'
                      [ngClass]="{'uncompleted':!BusinessDetailsBasic.valid && BusinessDetailsBasic.touched,'active':tabvis==0,'completed':BusinessDetailsBasic.valid}">
                      Basic Details</li>
                    <!-- <li (click)='goToTab(1)' *ngIf="RegType == 1"
                      [ngClass]="{'uncompleted':!CannabisDetails.valid && CannabisDetails.touched,'active':tabvis==1,'completed':CannabisDetails.valid}">
                      Cannabis Related Details
                    </li> 
                    <li (click)='goToTab(2)' [ngClass]="{'uncompleted':!BankDetails.valid && BankDetails.touched,'active':tabvis==2,'completed':BankDetails.valid}">
                      Business Bank Account Details</li>   -->
                    <li (click)='goToTab(1)'
                      [ngClass]="{'uncompleted':!ContactDetails.valid && ContactDetails.touched  || isDupPhone,'active':tabvis==1,'completed':ContactDetails.valid}">
                      Contact Details</li>
                    <li (click)='goToTab(2)'
                      [ngClass]="{'uncompleted':UserList.length == 0,'active':tabvis==2,'completed':UserList.length > 0}">
                      Key Person Registration</li>
                  </ul>
                </div>
                <div class="col-12 fed_backwd_group">
                  <div class="row h-100 align-content-end">
                    <div class="tabbutton  col-6 p-1">
                      <button mat-stroked-button color="primaryStrCus" (click)="goTOBackTab()"
                        class="control_back_button col-12 p-0 text-center" *ngIf="tabvis!=0">BACK</button>
                      <button mat-stroked-button color="primaryStrCus" (click)="onCancelClone();"
                        class="control_back_button col-12 p-0 text-center" *ngIf="tabvis==0">Cancel</button>
                    </div>
                    <div class="tabbutton  col-6 p-1">
                      <button mat-raised-button color="primaryCus" (click)="goToNext()"
                        class="frwd_button control_buttons p-0 col-12 text-center">{{tabBtnLabBus}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="My Applications">
      <div class='innerWizard'>
        
        <div class="row">
          <div class="col-md-2 offset-md-5 mt-4 mb-4">
            <div class="d-flex flex-column justify-content-center mini_icons r-section">
            <mat-form-field class="titleCardSelect" *ngIf="!commentsList && kycStatus==0">
              <mat-select placeholder="Select Business Type" (selectionChange)="setBiz($event)" [formControl]="selectedBusinessRetool">
                <mat-option  *ngFor ="let item of businessList" [value]="item.bp_business_id"
                class="info-details" matTooltipClass="matToolTip" matTooltip="  {{item.biz_display_name}} - {{item.bp_business.account_id}}"> {{item.biz_display_name}} - {{item.bp_business.account_id}} </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <div class="noti" *ngIf="kycStatus==2">
              User Membership Pending
              <div class="close" (click)="pendingNotification()"></div>
            </div> -->
          </div>
        </div>
        </div>

        <iframe width="100%" height="800px" frameBorder="0" [src]="urlSafe" scrolling="no"></iframe>
     <!-- <app-universal-app></app-universal-app> -->
      </div>
    </mat-tab>
    <mat-tab label="Task Manager">
      <div *ngIf="!showChildComponent">
          <div class='innerWizard'>
            
            <div class="row">
              <div class="col-md-2 offset-md-5 mt-4 mb-4">
                <div class="d-flex flex-column justify-content-center mini_icons r-section">
                  <mat-form-field class="titleCardSelect">
                  <mat-select placeholder="Select Business Type" (selectionChange)="setBiz($event)" [formControl]="selectedBusinessRetool">
                    <mat-option  *ngFor ="let item of businessList" [value]="item.bp_business_id"
                    class="info-details" matTooltipClass="matToolTip" matTooltip="  {{item.biz_display_name}} - {{item.bp_business.account_id}}"> {{item.biz_display_name}} - {{item.bp_business.account_id}} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            </div>
    
          </div>
          <div class="wizard form_wizard ">
            <mat-tab-group [selectedIndex]="selectedTaskIndex">
          
              <mat-tab label="All Tasks">
        
                <mat-card class="matC">
                    <form [formGroup]='searchinput'>
                        <div class="comply row">
                            <div class="col-sm-3 col-xs-12 col-lg-3 col-md-3">
                                <mat-form-field class=" w-100">
                                    <input matInput placeholder="Task Name" formControlName='search_field'
                                        name='search_field'>
                                    <mat-error>Maximum 100 Characters Allowed </mat-error>
                                </mat-form-field>
                                <div class="close-btn right-3" *ngIf="searchinput.value.search_field"
                                    (click)="searchinput.patchValue({search_field :''});filterValidation(0)">
                                </div>
                            </div>
                            <div class="col-sm-2 col-xs-12 col-lg-2 col-md-2 ">
                                <mat-form-field class="col-12">
                                    <mat-select placeholder="Status" formControlName='task_status'
                                        name='Task Status' multiple>
                                        <mat-option *ngFor="let item of singleTaskStatus; let i = index"
                                            [value]='item.status'>
                                            {{item.status_name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="close-btn" *ngIf="searchinput.value.task_status"
                                    (click)="searchinput.patchValue({task_status :''});filterValidation(0)">
                                </div>
                            </div>
                            <div class="col-sm-4 col-xs-12 col-lg-4 col-md-4">
                                <button class="blue_button" mat-flat-button color="accent"
                                    (click)="filterValidation(0)">Search</button>
                                    <button class="ml-2" mat-stroked-button color="primaryCus" (click)="openFilterDialog('AM_ALL_TASK')">
                                        Advanced Search</button>
        
                                <span *ngIf='isFiltered' (click)="clearFilter()"><img class="img_button ml-2"
                                        src='assets/images/filtered.png'></span>
                                <span *ngIf='!isFiltered'><img class="img_button ml-2"
                                        src="assets/images/filterempty.png"></span>
                            </div>
        
                            <div class="col-sm-3 col-xs-12 col-lg-3 col-md-3">
                                <span (click)="reloadOrder()"><img class="img_button float-right" src="assets/images/reset.svg"></span>
                            </div>
        
                        </div>
                    </form>
                    <div class="mat-elevation-z1 checkBoxlign">
                        <div class="table-responsive striped users_mod limit_height">
                            <table class="col-12 multi_header_table fixed_layout  scrollling_table" mat-table matSort [dataSource]="taskDetails">
                                <ng-container matColumnDef="Task Name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="task_name" style="width: 30%;">
                                        Task Name
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element?.task_name}}</td>
                                </ng-container>
        
                              <ng-container matColumnDef="Due Date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="due_date" style="width: 8%;">
                                        Due Date
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element?.due_date | date : 'MMM dd, yyyy' }}</td>
                                </ng-container>
        
                                <ng-container matColumnDef="Assignee">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="assign_um_user_fullname" class="w120-container">
                                        Assignee
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element?.assign_um_user_fullname}}</td>
                                </ng-container>
                                
                                <ng-container matColumnDef="Created Date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="created" style="width: 8%;">
                                        Created Date
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element?.created | date : 'MMM dd, yyyy'}}</td>
                                </ng-container>
        
        
                                <ng-container matColumnDef="Created By"
                                >
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="createdby_fullname"
                                        class="w120-container">
                                        Created By
                                    </th>
                                    <td mat-cell *matCellDef="let element">{{element?.creating_bp_business_name}}</td>
                                </ng-container>
                                <ng-container matColumnDef="Status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status" style="width: 10%;"> Status </th>
                                    <td mat-cell *matCellDef="let element">
                                        <span class="status_management"
                                            [ngStyle]="{ 'background-color': getStatusColor(element.status) }">{{element?.status_name}}</span>
                                    </td>
                                </ng-container>
        
        
                                <ng-container matColumnDef="Action" stickyEnd>
                                    <th class="checkbox_width" mat-header-cell *matHeaderCellDef  style="width: 2% !important;"></th>
                                    <td class="checkbox_width" mat-cell *matCellDef="let row" (click)='$event.stopPropagation();getKebabMenu(row)'>
                                        <mat-icon class="pointer" [matMenuTriggerFor]="tableRowMenu"
                                        (click)='$event.stopPropagation();getKebabMenu(row)'>
                                            more_vert</mat-icon>
                                        <mat-menu #tableRowMenu="matMenu">
                                            <ul class="tableRowEdit">
                                                <li *ngFor="let menu of dynamicUserActionMenu"
                                                    [ngClass]="getMenuIcon(menu)"><span
                                                        (click)="dotMenuClicked(row, menu.action_name)">{{
                                                        menu.action_name }}</span></li>
                                            </ul>
                                        </mat-menu>
                                    </td>
                                </ng-container>
        
        
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dotMenuClicked(row, 'View')"></tr>
                            </table>
                        </div>
                        <div class="col-12 text-center" *ngIf="taskDetails.length == 0">
                            <span class="NoDataFound">
                                No Data Found
                            </span>
                        </div>
                        <div class="col-12 bgWhite">
                            <div class="row align-items-center ">
                                <div class="col-12">
                                    <mat-paginator *ngIf="taskDetails?.length != 0"
                                        [pageSizeOptions]="page.pageSizeOptions"
                                        [length]="page.limit"
                                        [pageSize]="page.pageSize"
                                        (page)="PageChangeUser($event)"
                                        [pageIndex]="page.index"
                                        showFirstLastButtons></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card>
              
              </mat-tab>
              </mat-tab-group>
          </div>

    </div>
      <div *ngIf="showChildComponent">
        <app-view-task-management [taskId]="taskID" [businessID]="current_bp_business_id" (back)="showParent()"></app-view-task-management>
      </div>
    </mat-tab>

    <mat-tab label="Identity Verification" *ngIf="!is_idme_verified">
      <div class="row m-0 h-100 login_container">

        <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 offset-md-4 setPadding mt-4">
                <mat-card class="matC">
                <form class="" [formGroup]='search_input'>
                  <div class="row m-0">
                    <div class="col-12 p-0 email">
                      <mat-form-field class="col-12">
                        <input type="text" matInput placeholder="First Name" formControlName="first_name">
                        <mat-error *ngIf="search_input.get('first_name').errors?.required">Enter First Name</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-12 p-0 email">
                      <mat-form-field class="col-12">
                        <input type="email" matInput placeholder="Last Name" formControlName="last_name">
                        <mat-error *ngIf="search_input.get('last_name').errors?.required">Enter Last Name</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-12 p-0 email">
                      <mat-form-field class="col-12">
                        <input type="email" matInput placeholder="Email Address" formControlName="user_email">
                        <mat-error *ngIf="search_input.get('user_email').errors?.required">Enter Email</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </form>
                <div class="text-right col-12 ">
                  <button  mat-raised-button (click) = 'openPopUP()' class="mx-2"
                  color="primaryCus">Verify Your Identity</button>
                </div>
                </mat-card>
              </div>
            </div>
    </mat-tab>
  </mat-tab-group>
</div>
